<template>
  <div class="md-layout">
    <CSLoading :is-loading="isLoading"></CSLoading>
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green sp-card-header">
          <div class="card-icon">
            <md-icon>local_shipping</md-icon>
          </div>
          <h4 class="title">{{ $t("shippingPlan.shippingPlans") }}</h4>
        </md-card-header>
        <md-card-content class="sp-card-content">
          <div class="table-sticky">
            <v-server-table :columns="tableColumns" :options="tableOptions" ref="table" class="table-shipping-plan" id="shipping-plan-table">
              <template #h__status>
                <div class="head-status" style="text-align: left; width: 100px">
                  {{ $t("shippingPlan.table.status") | capitalized }} <br />
                  {{ $t("shippingPlan.table.labels") | capitalized }}
                </div>
              </template>
              <template #h__supplier>
                <div class="head-supplier" style="text-align: left; width: 100px">
                  {{ $t("shippingPlan.table.order") }}
                  {{ $t("shippingPlan.table.id") | uppercase }}
                  <br />
                  {{ $t("shippingPlan.table.supplier") }}
                </div>
              </template>
              <template #h__shipment>
                <div class="head-shipment" style="width: 200px; text-align: left">
                  {{ $t("shippingPlan.table.shipmentName") }}<br />
                  {{ $t("shippingPlan.table.container") | capitalized }}#&nbsp;|&nbsp;{{ $t("shippingPlan.table.containerSize") }} | {{ $t("shippingPlan.table.carrier") }}
                </div>
              </template>
              <template #h__documents>
                <div class="head-documents" style="width: 100px">
                  {{ $t("shippingPlan.table.documents") }}
                </div>
              </template>
              <template #h__arrival>
                <div class="head-arrival" style="width: 200px; text-align: left">
                  {{ $t("shippingPlan.table.arrivalDestination") }} <br />
                  {{ $t("shippingPlan.table.arrivalDateAndTime") }}
                </div>
              </template>
              <template #h__payment>
                <div class="head-payment" style="width: 100px; text-align: left">
                  {{ $t("shippingPlan.table.totalAmount") }} <br />
                  {{ $t("shippingPlan.table.prepayment") }} | {{ $t("shippingPlan.table.finalPayment") }}
                </div>
              </template>
              <template #h__freight>
                <div class="head-freight">
                  {{ $t("shippingPlan.table.freight") }} <br />
                  {{ $t("shippingPlan.table.customs") }}
                </div>
              </template>
              <template #h__accounting>
                <div class="head-accounting" style="width: 90px">
                  {{ $t("shippingPlan.table.accounting") }}
                </div>
              </template>

              <template #actions="{ row }">
                <div class="text-center md-table-cell-container">
                  <div class="cell-actions text-center">
                    <md-button
                      v-if="hasPermission('LimitRead', 'ShippingPlans', 'History')"
                      @click="
                        currentShipmentRecordId = row.shipmentRecordId;
                        historicalModal = true;
                      "
                      class="md-icon-button"
                    >
                      <md-icon>history</md-icon>
                    </md-button>
                    <md-button v-if="hasPermission('Write', 'ShippingPlans', 'Edit')" class="md-icon-button" @click="showEditModal(row)"><md-icon>edit</md-icon></md-button>
                    <md-button
                      v-if="hasPermission('Write', 'ShippingPlans', 'BookWms') && !row.wmsGebucht"
                      class="md-icon-button"
                      :title="$t('shippingPlan.wms.bookAction')"
                      @click="openWmsBooking(row)"
                      ><img src="/img/occ_logo_icon_64px.svg" alt="OCC" class="action-logo action-logo--occ"
                    /></md-button>
                    <md-button
                      v-if="hasPermission('Write', 'ShippingPlans', 'BookAfterbuy') && !row.afterbuyGebucht"
                      class="md-icon-button"
                      :title="$t('shippingPlan.afterbuy.bookAction')"
                      @click="openAfterbuyBooking(row)"
                      ><img src="/img/afterbuy_logo_icon_64px.svg" alt="Afterbuy" class="action-logo action-logo--afterbuy"
                    /></md-button>
                    <md-button
                      v-if="hasPermission('Write', 'ShippingPlans', 'SendAccounting') && row.commercialInvoice && row.accountingStatus !== 'Transferred'"
                      class="md-icon-button"
                      :title="$t('shippingPlan.sendCI')"
                      @click="sendDocumentCIRow(row)"
                      ><img src="/img/datev_logo_icon_64px.svg" alt="Datev" class="action-logo action-logo--datev"
                    /></md-button>
                    <md-button
                      v-if="!row.canRelease && !canForceRelease() && row.blockedBy"
                      class="md-icon-button lock-other-user"
                      :title="$t('shippingPlan.messages.blockedBy', { user: row.blockedBy })"
                      ><md-icon>lock</md-icon></md-button
                    >
                    <md-button
                      v-if="!row.canRelease && canForceRelease() && row.blockedBy"
                      class="md-icon-button lock-other-user lock-admin-release"
                      :title="forceReleaseTitle(row)"
                      @click="confirmForceRelease(row)"
                      ><md-icon>lock</md-icon></md-button
                    >
                    <md-button
                      v-if="hasPermission('Write', 'ShippingPlans', 'Edit') && row.canRelease === true"
                      class="md-icon-button"
                      :title="$t('shippingPlan.messages.blockedBy', { user: row.blockedBy })"
                      @click="release(row)"
                      ><md-icon style="color: #f44336">lock</md-icon></md-button
                    >
                    <!-- Splitten nur solange nichts ins WMS gebucht ist - danach ist die
                         Aufteilung nicht mehr rueckabwickelbar. -->
                    <md-button
                      v-if="hasPermission('Write', 'ShippingPlans', 'Split') && !row.wmsGebucht"
                      class="md-icon-button md-info split-button"
                      :title="$t('shippingPlan.split.action')"
                      @click="showSplitModal(row)"
                    >
                      <md-icon md-src="/img/arrow_split.svg" />
                    </md-button>
                    <!-- Gebuchte Vorgaenge sind nicht loeschbar (keine Rueckabwicklung), deshalb
                         wird der Knopf dort gar nicht erst angeboten. -->
                    <md-button
                      v-if="hasPermission('Write', 'ShippingPlans', 'Delete') && !row.wmsGebucht && !row.afterbuyGebucht"
                      class="md-icon-button md-danger"
                      :title="$t('shippingPlan.delete.action')"
                      @click="confirmDelete(row)"
                    >
                      <md-icon>delete</md-icon>
                    </md-button>
                  </div>
                </div>
              </template>
              <template #status="{ row }">
                <div class="cell-status">
                  <md-chip v-if="hasPermission('LimitRead', 'ShippingPlans', 'RecordStatus')" :style="`background-color: ${row.recordStatusColor} !important; color: #fff !important`">{{ getI18N("shippingPlan.statuses.recordStatuses", row.recordStatus) }}</md-chip>
                  <record-tag v-if="hasPermission('LimitRead', 'ShippingPlans', 'RecordTags')" :recordTag="row.recordTags" :recordTags="recordTags"></record-tag>
                </div>
              </template>
              <template #notes="{ row }">
                <div class="cell-notes">
                  <span v-if="hasPermission('LimitRead', 'ShippingPlans', 'ShipmentNote') && row.shipmentNote" class="text-success material-symbols-outlined" v-hover-tip="row.shipmentNote">
                    sticky_note_2
                  </span>
                  <span v-else class="text-gray material-symbols-outlined"> sticky_note_2 </span>
                </div>
              </template>
              <template #supplier="{ row }">
                <div class="cell-supplier">
                  <span v-if="hasPermission('LimitRead', 'ShippingPlans', 'SupplierOrderId')">{{ row.supplierOrderId }}</span>
                  <br />
                  <strong v-if="hasPermission('LimitRead', 'ShippingPlans', 'SupplierName')">
                    <hover-tip
                      :disabled="
                        !supplierByName[row.supplierName] ||
                        !(supplierByName[row.supplierName].nameFull || supplierByName[row.supplierName].creditor != null || supplierByName[row.supplierName].bankId)
                      "
                    >
                      <a v-if="row.supplierNameId" href="javascript:void(0)" class="supplier-link" @click="filterBySupplier(row)">{{ row.supplierName }}</a>
                      <template v-else>{{ row.supplierName }}</template>
                      <template #tip>
                        <div v-if="supplierByName[row.supplierName].nameFull">{{ supplierByName[row.supplierName].nameFull }}</div>
                        <div v-if="supplierByName[row.supplierName].creditor != null">{{ $t("suppliers.creditor") }}: {{ supplierByName[row.supplierName].creditor }}</div>
                        <div v-if="supplierByName[row.supplierName].bankId">{{ $t("suppliers.bankId") }}: {{ supplierByName[row.supplierName].bankId }}</div>
                      </template>
                    </hover-tip>
                  </strong>
                  <span
                    v-if="supplierByName[row.supplierName] && supplierByName[row.supplierName].creditor != null"
                    @click="copyCreditor(supplierByName[row.supplierName].creditor)"
                    style="cursor: pointer"
                    v-hover-tip="$t('suppliers.copyCreditor')"
                    ><span class="text-gray material-symbols-outlined" style="font-size: 15px !important; vertical-align: middle">content_copy</span></span
                  >
                </div>
              </template>
              <template #shipment="{ row }">
                <div class="cell-shipment">
                  <span class="cell-shipment-carrier">
                    <CarrierInfo
                      v-if="hasPermission('LimitRead', 'ShippingPlans', 'CarrierName') && hasPermission('LimitRead', 'ShippingPlans', 'CarrierShipmentId')"
                      :carrier-name="row.carrierName"
                      :carrier-name-id="row.carrierNameId"
                      :carrier-shipment-id="row.carrierShipmentId"
                      :booking-status="row.containerBookingStatus"
                      :booking-date="row.containerBookingDate"
                    ></CarrierInfo>
                  </span>
                  <span class="cell-shipment-text">
                    <strong v-if="hasPermission('LimitRead', 'ShippingPlans', 'ShipmentRecordName')">{{ row.shipmentRecordName }}</strong>
                    <br />
                    <span v-if="hasPermission('LimitRead', 'ShippingPlans', 'ContainerId') && row.containerId"
                      ><a v-if="row.trackingUrl" :href="row.trackingUrl" target="_blank">{{ row.containerId }}</a
                      ><span v-else>{{ row.containerId }}</span>
                      <span @click="() => copyContainerId(row.containerId)" class="copy-containerid"
                        ><span class="text-gray material-symbols-outlined" style="font-size: 15px !important">content_copy</span></span
                      >
                    </span>
                    <span v-if="hasPermission('LimitRead', 'ShippingPlans', 'ContainerSize') && row.containerSize" class="text-gray">({{ row.containerSize }})</span>
                  </span>
                </div>
              </template>

              <template #documents="{ row }">
                <div class="cell-documents">
                  <span
                    style="cursor: pointer"
                    v-if="hasPermission('LimitRead', 'ShippingPlans', 'ProformaInvoice') && row.proformaInvoice"
                    v-hover-tip="row.proformaInvoice"
                    @click="
                      downloadDocument({
                        id: row.shipmentRecordId,
                        name: row.proformaInvoice,
                      })
                    "
                  >
                    <span class="doc-icon-wrap">
                      <span class="text-success material-symbols-outlined">receipt_long</span>
                      <span v-if="documentChecked(row, 'proforma_invoice')" class="doc-checked-badge"><span class="material-symbols-outlined">check</span></span>
                    </span>
                    <span class="text-success cell-documents-text">PI</span>
                  </span>
                  <span v-else v-hover-tip="row.proformaInvoice">
                    <span class="text-gray material-symbols-outlined">receipt_long</span>
                    <span class="text-gray cell-documents-text">PI</span>
                  </span>
                  <span
                    style="cursor: pointer"
                    v-if="hasPermission('LimitRead', 'ShippingPlans', 'CommercialInvoice') && row.commercialInvoice"
                    v-hover-tip="row.commercialInvoice"
                    @click="
                      downloadDocument({
                        id: row.shipmentRecordId,
                        name: row.commercialInvoice,
                      })
                    "
                  >
                    <span class="doc-icon-wrap">
                      <span class="text-success material-symbols-outlined">receipt_long</span>
                      <span v-if="documentChecked(row, 'commercial_invoice')" class="doc-checked-badge"><span class="material-symbols-outlined">check</span></span>
                    </span>
                    <span class="text-success cell-documents-text">CI</span>
                  </span>
                  <span v-else v-hover-tip="row.commercialInvoice">
                    <span class="text-gray material-symbols-outlined">receipt_long</span>
                    <span class="text-gray cell-documents-text">CI</span>
                  </span>
                  <span
                    style="cursor: pointer"
                    v-if="hasPermission('LimitRead', 'ShippingPlans', 'PackingList') && row.packingList"
                    v-hover-tip="row.packingList"
                    @click="
                      downloadDocument({
                        id: row.shipmentRecordId,
                        name: row.packingList,
                      })
                    "
                  >
                    <span class="doc-icon-wrap">
                      <span class="text-success material-symbols-outlined">receipt_long</span>
                      <span v-if="documentChecked(row, 'packing_list')" class="doc-checked-badge"><span class="material-symbols-outlined">check</span></span>
                    </span>
                    <span class="text-success cell-documents-text">PL</span>
                  </span>
                  <span v-else v-hover-tip="row.packingList">
                    <span class="text-gray material-symbols-outlined">receipt_long</span>
                    <span class="text-gray cell-documents-text">PL</span>
                  </span>
                </div>
              </template>
              <template #arrival="{ row }">
                <div class="cell-arrival">
                  <destination-info
                    v-if="hasPermission('LimitRead', 'ShippingPlans', 'ContainerArrivalPlace')"
                    :placeId="row.containerArrivalPlaceId"
                    :placeName="row.containerArrivalPlace"
                    :displayName="shortPlaceName(row.containerArrivalPlace)"
                  ></destination-info>
                  <br />
                  <strong v-if="hasPermission('LimitRead', 'ShippingPlans', 'ContainerArrivalDate') && row.containerArrivalDate"
                    >{{ row.containerArrivalDate | formatDayOfWeek }} {{ row.containerArrivalDate | formatDate }} | {{ row.containerArrivalDate | formatTime }}</strong
                  >
                </div>
              </template>
              <template #items="{ row }">
                <div class="cell-items">
                  <hover-tip :disabled="!(hasPermission('LimitRead', 'ShippingPlans', 'Products') && row.products && row.products.length > 0)">
                    <span
                      class="material-symbols-outlined"
                      :class="{
                        'text-success': row.products && row.products.length > 0,
                        'text-gray': !row.products || row.products.length === 0,
                      }"
                    >
                      package_2
                    </span>
                    <template #tip>
                      <table style="border-collapse:collapse;min-width:200px">
                        <thead><tr>
                          <th style="text-align:right;padding:0 8px 4px 0">{{ $t("shippingPlan.quantityDelivering") }}</th>
                          <th style="text-align:left;padding:0 8px 4px 0">SKU</th>
                          <th style="text-align:right;padding:0 0 4px 0">{{ $t("shippingPlan.purchasePrice") }}</th>
                        </tr></thead>
                        <tbody>
                          <tr v-for="p in row.products" :key="p.id">
                            <td style="text-align:right;padding:1px 8px 1px 0">{{ p.quantityDelivering }}</td>
                            <td style="text-align:left;padding:1px 8px 1px 0">{{ p.sku }}</td>
                            <td style="text-align:right;padding:1px 0"><span v-if="p.purchasePrice != null">{{ formatMoney(p.purchasePrice) }} $</span><span v-else>–</span></td>
                          </tr>
                        </tbody>
                        <tfoot><tr style="border-top:1px solid rgba(255,255,255,0.4)">
                          <td style="text-align:right;padding:4px 8px 0 0"><strong>{{ row.products.reduce((s,p) => s + (p.quantityDelivering||0), 0) }}</strong></td>
                          <td></td>
                          <td style="text-align:right;padding:4px 0 0 0"><strong>{{ formatMoney(row.products.reduce((s,p) => s + ((p.quantityDelivering||0)*(p.purchasePrice||0)), 0)) }} $</strong></td>
                        </tr></tfoot>
                      </table>
                    </template>
                  </hover-tip>
                </div>
              </template>
              <template #china="{ row }">
                <div class="cell-china">
                  <hover-tip direction="bottom">
                    <md-avatar :style="`border: 3px solid ${row.chinaStatusColor}`">
                      <user-avatar v-if="row.chinaUserAvatar" :user-id="row.chinaUser" alt="Avatar" />
                      <img v-else src="https://placehold.co/50" alt="Avatar" />
                    </md-avatar>
                    <template #tip>
                      <table class="china-tooltip">
                        <tr v-if="hasPermission('LimitRead', 'ShippingPlans', 'ChinaUser') && row.chinaUserFullName">
                          <td>{{ $t("shippingPlan.chinaUser") }}:</td>
                          <td>{{ row.chinaUserFullName }}</td>
                        </tr>
                        <tr v-if="hasPermission('LimitRead', 'ShippingPlans', 'ChinaStatus')">
                          <td>{{ $t("shippingPlan.chinaStatus") }}:</td>
                          <td>{{ getI18N("shippingPlan.statuses.chinaStatuses", row.chinaStatus) }}</td>
                        </tr>
                        <tr v-if="hasPermission('LimitRead', 'ShippingPlans', 'ChinaText') && row.chinaText">
                          <td>{{ $t("shippingPlan.chinaText") }}:</td>
                          <td>{{ row.chinaText }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t("shippingPlan.mtcStatus") }}:</td>
                          <td>{{ $t(`shippingPlan.documentStatuses.${row.mtcStatus || "pending"}`) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t("shippingPlan.coStatus") }}:</td>
                          <td>{{ $t(`shippingPlan.documentStatuses.${row.coStatus || "pending"}`) }}</td>
                        </tr>
                      </table>
                    </template>
                  </hover-tip>
                </div>
              </template>
              <template #payment="{ row }">
                <div class="cell-payment">
                  <span v-if="hasPermission('LimitRead', 'ShippingPlans', 'OrderTotalAmount')"
                    ><strong class="total-amount" v-if="row.orderTotalAmount">{{ row.orderTotalAmount | formatAmount }}</strong></span
                  >
                  <span class="prepayment" v-if="hasPermission('LimitRead', 'ShippingPlans', 'PrepaymentAmount') && row.orderTotalAmount">{{ (row.prepaymentAmount || 0) | formatAmount }}</span>
                  <span
                    class="full-payment"
                    v-if="
                      (hasPermission('LimitRead', 'ShippingPlans', 'OrderTotalAmount') && hasPermission('LimitRead', 'ShippingPlans', 'PrepaymentAmount') && row.prepaymentAmount) ||
                      row.orderTotalAmount
                    "
                    ><span
                      >{{ (row.orderTotalAmount - row.prepaymentAmount) | formatAmount }}
                      <span v-if="row.paymentStatus === 'Paid in Full'" class="text-success material-symbols-outlined">done</span>
                      <span v-else class="text-danger material-symbols-outlined">close</span>
                    </span>
                  </span>
                </div>
              </template>
              <template #freight="{ row }">
                <div class="cell-freight">
                  <span
                    v-if="hasPermission('LimitRead', 'ShippingPlans', 'ShipmentPaidStatus')"
                    :style="row.freightInvoice ? 'cursor: pointer' : ''"
                    @click="row.freightInvoice && downloadDocument({ id: row.shipmentRecordId, name: row.freightInvoice })"
                    v-hover-tip="[$t('shippingPlan.shipmentPaidStatus') + ': ' + (row.shipmentPaidStatus ? getI18N('shippingPlan.statuses.shipmentPaidStatuses', row.shipmentPaidStatus) : '–'), row.shipmentDocumentNumber ? $t('shippingPlan.shipmentDocumentNumber') + ': ' + row.shipmentDocumentNumber : null, row.shipmentAmount != null ? $t('shippingPlan.shipmentAmount') + ': ' + formatMoney(row.shipmentAmount) + ' €' : null, row.freightInvoice ? $t('shippingPlan.clickToPreview') : null].filter(Boolean).join('\n')">
                    <span
                      :class="{
                        'text-success': row.shipmentPaidStatus === 'Paid',
                        'text-gray': row.shipmentPaidStatus !== 'Paid',
                        'doc-linked': row.freightInvoice,
                      }"
                      class="material-symbols-outlined"
                      >request_quote</span
                    >
                  </span>
                  <span
                    v-if="hasPermission('LimitRead', 'ShippingPlans', 'CustomsPaidStatus')"
                    :style="row.customsInvoice ? 'cursor: pointer' : ''"
                    @click="row.customsInvoice && downloadDocument({ id: row.shipmentRecordId, name: row.customsInvoice })"
                    v-hover-tip="[$t('shippingPlan.customsPaidStatus') + ': ' + (row.customsPaidStatus ? getI18N('shippingPlan.statuses.customsPaidStatuses', row.customsPaidStatus) : '–'), row.customsDocumentNumber ? $t('shippingPlan.customsDocumentNumber') + ': ' + row.customsDocumentNumber : null, row.customsAmount != null ? $t('shippingPlan.customsAmount') + ': ' + formatMoney(row.customsAmount) + ' €' : null, row.customsInvoice ? $t('shippingPlan.clickToPreview') : null].filter(Boolean).join('\n')">
                    <span
                      :class="{
                        'text-success': row.customsPaidStatus === 'Paid',
                        'text-gray': row.customsPaidStatus !== 'Paid',
                        'doc-linked': row.customsInvoice,
                      }"
                      class="material-symbols-outlined"
                      >request_quote</span
                    >
                  </span>
                </div>
              </template>
              <template #accounting="{ row }">
                <div class="cell-accounting" v-if="hasPermission('LimitRead', 'ShippingPlans', 'AccountingStatus')">
                  <div class="accounting-status-grid">
                    <span
                      class="status-pill"
                      :class="row.accountingStatus === 'Transferred' ? 'status-pill--on' : 'status-pill--off'"
                      v-hover-tip="
                        row.accountingStatus === 'Transferred' && row.accountingStatusDate && hasPermission('LimitRead', 'ShippingPlans', 'AccountingStatusDate')
                          ? `${$t('shippingPlan.sentToAccounting')}: ${$options.filters.formatMonthYear(row.accountingStatusDate)}`
                          : $t('shippingPlan.accountingStatus')
                      "
                    >
                      <span class="status-pill-badge status-pill-badge--logo status-pill-badge--datev"><img src="/img/datev_logo_icon_64px.svg" alt="Datev" /></span>
                    </span>
                    <span class="status-pill" :class="row.productDataSent ? 'status-pill--on' : 'status-pill--off'" v-hover-tip="$t('shippingPlan.productDataSent')">
                      <span class="status-pill-badge"><span class="material-symbols-outlined">inventory_2</span></span>
                    </span>
                    <span class="status-pill" :class="row.afterbuyGebucht ? 'status-pill--on' : 'status-pill--off'" v-hover-tip="$t('shippingPlan.afterbuyBooked')">
                      <span class="status-pill-badge status-pill-badge--logo"><img src="/img/afterbuy.png" alt="Afterbuy" /></span>
                    </span>
                    <span class="status-pill" :class="row.wmsGebucht ? 'status-pill--on' : 'status-pill--off'" v-hover-tip="$t('shippingPlan.wmsBooked')">
                      <span class="status-pill-badge status-pill-badge--logo"><img src="/img/occ.png" alt="OCC" /></span>
                    </span>
                  </div>
                </div>
              </template>
            </v-server-table>
          </div>
        </md-card-content>
      </md-card>

      <modal v-if="editModal" @close="hideEditModal" class-name="shipping-plan-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.editShippingPlan") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideEditModal">
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <ValidationObserver v-slot="{}" ref="form">
            <tabs
              :tab-name="[
                $t('shippingPlan.shipment'),
                $t('shippingPlan.order'),
                $t('shippingPlan.articles'),
                $t('shippingPlan.documents'),
                $t('shippingPlan.china'),
                $t('shippingPlan.accounting'),
              ]"
              color-button="success"
              content-flex-direction-column
            >
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <ValidationProvider name="shipmentRecordName" rules="required" v-slot="{ errors }">
                      <md-field>
                        <label>{{ $t("shippingPlan.shipmentRecordName") }}</label>
                        <md-input v-model="form.shipmentRecordName"></md-input>
                        <div class="md-error" v-if="errors[0]">
                          {{ $t(errors[0]) }}
                        </div>
                      </md-field>
                    </ValidationProvider>
                    <div class="wrap-v-select mb-3">
                      <label class="v-select-label">{{ $t("shippingPlan.recordStatus") }}</label>
                      <v-select
                        :options="recordStatusOptions"
                        :value="recordStatusOptions.find(i => i.id === form.recordStatusId)"
                        @input="val => form.recordStatusId = val ? val.id : null"
                        :getOptionLabel="i => getI18N('shippingPlan.statuses.recordStatuses', i.name)"
                        :clearable="true"
                      >
                        <template #option="option">
                          <md-chip :style="`background-color: ${option.color || '#999'} !important; color: #fff !important`">{{ getI18N("shippingPlan.statuses.recordStatuses", option.name) }}</md-chip>
                        </template>
                        <template #selected-option="option">
                          <md-chip :style="`background-color: ${option.color || '#999'} !important; color: #fff !important`">{{ getI18N("shippingPlan.statuses.recordStatuses", option.name) }}</md-chip>
                        </template>
                      </v-select>
                    </div>
                    <!-- Sticker nur aus der Liste waehlen; neue/geaenderte Sticker ueber den "+"-Dialog (Trello 26.08.2026) -->
                    <div class="record-tag-row">
                      <div class="wrap-v-select mb-3 record-tag-row__select">
                        <label class="v-select-label">{{ $t("shippingPlan.addRecordTag") }}</label>
                        <record-tag-select :value="tags.map((t) => t.text)" @input="(names) => (tags = names.map((n) => colorizeTag(n)))" />
                      </div>
                      <!-- Stift statt "+": im Dialog wird angelegt UND bearbeitet (Michael 27.08.) -->
                      <md-button class="md-just-icon md-round md-simple md-sm record-tag-row__add" :title="$t('shippingPlan.recordTagManager.manage')" @click="recordTagManager = true">
                        <md-icon>edit</md-icon>
                      </md-button>
                    </div>
                    <div class="wrap-v-select mb-3">
                      <label class="v-select-label">{{ $t("shippingPlan.containerSize") }}</label>
                      <v-select
                        :options="containerSizeOptions"
                        :value="containerSizeOptions.find(i => i.id === form.containerSizeId)"
                        @input="val => form.containerSizeId = val"
                        :reduce="i => i.id"
                        :getOptionLabel="i => getI18N('shippingPlan.statuses.containerSizes', i.name)"
                        :clearable="true"
                      ></v-select>
                    </div>
                    <p class="date-title">
                      {{ $t("shippingPlan.containerArrivalDate") }}
                    </p>
                    <date-time-picker
                      :startDate="form.containerArrivalDateInput"
                      :singleDate="true"
                      @onChange="(d) => (form.containerArrivalDateInput = d.startDate)"
                      class="datetime-input"
                      timeFormat="HH:mm"
                    />
                    <div style="display: flex; gap: 16px; align-items: center; margin: 8px 0;">
                      <md-radio v-model="containerArrivalDateType" value="fixed">{{ $t("shippingPlan.dateIsFixed") }}</md-radio>
                      <md-radio v-model="containerArrivalDateType" value="planned">{{ $t("shippingPlan.planned") }}</md-radio>
                      <md-radio v-model="containerArrivalDateType" value="provisional">{{ $t("shippingPlan.provisional") }}</md-radio>
                    </div>
                    <md-field class="shipment-note-field">
                      <label>{{ $t("shippingPlan.shipmentNote") }}</label>
                      <md-textarea v-model="form.shipmentNote" md-autogrow></md-textarea>
                    </md-field>
                    <div class="wrap-v-select mb-3">
                      <label class="v-select-label">{{ $t("shippingPlan.containerArrivalPlace") }}</label>
                      <v-select
                        :options="containerArrivalPlaceOptions"
                        :value="containerArrivalPlaceOptions.find(i => i.id === form.containerArrivalPlaceId)"
                        @input="val => form.containerArrivalPlaceId = val ? val.id : null"
                        label="name"
                        :clearable="true"
                      >
                        <template #option="option">
                          <img v-if="option.logo" :src="option.logo" style="height:18px;width:auto;vertical-align:middle;margin-right:6px" />
                          <md-icon v-else style="font-size:18px !important;vertical-align:middle;margin-right:4px">warehouse</md-icon>
                          {{ option.name }}
                        </template>
                        <template #selected-option="option">
                          <img v-if="option.logo" :src="option.logo" style="height:18px;width:auto;vertical-align:middle;margin-right:6px" />
                          <md-icon v-else style="font-size:18px !important;vertical-align:middle;margin-right:4px">warehouse</md-icon>
                          {{ option.name }}
                        </template>
                      </v-select>
                    </div>
                    <div style="display: flex; justify-content: flex-start; margin-bottom: 8px;">
                      <md-checkbox v-model="form.productDataSent">{{ $t("shippingPlan.productDataSent") }}</md-checkbox>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <div class="wrap-v-select mb-3">
                      <label class="v-select-label">{{ $t("shippingPlan.carrierName") }}</label>
                      <v-select
                        :options="carrierNameOptions"
                        :value="carrierNameOptions.find(i => i.id === form.carrierNameId)"
                        @input="val => form.carrierNameId = val ? val.id : null"
                        label="name"
                        :clearable="true"
                      >
                        <template #option="option">
                          <img v-if="option.logo" :src="option.logo" style="height:18px;width:auto;vertical-align:middle;margin-right:6px" />
                          <md-icon v-else style="font-size:18px !important;vertical-align:middle;margin-right:4px">sailing</md-icon>
                          {{ option.name }}
                        </template>
                        <template #selected-option="option">
                          <img v-if="option.logo" :src="option.logo" style="height:18px;width:auto;vertical-align:middle;margin-right:6px" />
                          <md-icon v-else style="font-size:18px !important;vertical-align:middle;margin-right:4px">sailing</md-icon>
                          {{ option.name }}
                        </template>
                      </v-select>
                    </div>
                    <md-field>
                      <label for="containerBookingStatus">{{ $t("shippingPlan.containerBookingStatus") }}</label>
                      <md-select v-model="form.containerBookingStatus" name="containerBookingStatus" id="containerBookingStatus">
                        <md-option value="pending">{{ $t("shippingPlan.bookingStatus.pending") }}</md-option>
                        <md-option value="requested">{{ $t("shippingPlan.bookingStatus.requested") }}</md-option>
                        <md-option value="confirmed">{{ $t("shippingPlan.bookingStatus.confirmed") }}</md-option>
                      </md-select>
                    </md-field>
                    <date-picker
                      v-model="form.containerBookingDateInput"
                      format="YYYY-MM-DD"
                      type="date"
                      :placeholder="$t('shippingPlan.containerBookingDate')"
                      style="width: 100%; margin-bottom: 16px;"
                    ></date-picker>
                    <md-field>
                      <label>{{ $t("shippingPlan.containerId") }}</label>
                      <md-input v-model="form.containerId"></md-input>
                    </md-field>
                    <md-field>
                      <label>{{ $t("shippingPlan.carrierShipmentId") }}</label>
                      <md-input v-model="form.carrierShipmentId"></md-input>
                    </md-field>
                    <md-field>
                      <label>{{ $t("shippingPlan.trackingUrl") }}</label>
                      <md-input v-model="form.trackingUrl"></md-input>
                    </md-field>
                    <div class="md-layout md-gutter">
                      <div class="md-layout-item md-size-40">
                        <md-field>
                          <label for="shipmentPaidStatus">{{ $t("shippingPlan.shipmentPaidStatus") }}</label>
                          <md-select v-model="form.shipmentPaidStatusId" name="shipmentPaidStatus" id="shipmentPaidStatus">
                            <md-option :key="i.id" v-for="i in shipmentPaidStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.shipmentPaidStatuses", i.name) }}</md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-30">
                        <md-field>
                          <label>{{ $t("shippingPlan.shipmentDocumentNumber") }}</label>
                          <md-input v-model="form.shipmentDocumentNumber"></md-input>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-30">
                        <md-field>
                          <label>{{ $t("shippingPlan.shipmentAmount") }}</label>
                          <md-input v-model="form.shipmentAmount" type="text" inputmode="decimal" @blur="formatMoneyField('shipmentAmount')"></md-input>
                        </md-field>
                      </div>
                    </div>
                    <div class="md-layout md-gutter">
                      <div class="md-layout-item md-size-40">
                        <md-field>
                          <label for="customsPaidStatus">{{ $t("shippingPlan.customsPaidStatus") }}</label>
                          <md-select v-model="form.customsPaidStatusId" name="customsPaidStatus" id="customsPaidStatus">
                            <md-option :key="i.id" v-for="i in customsPaidStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.customsPaidStatuses", i.name) }}</md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-30">
                        <md-field>
                          <label>{{ $t("shippingPlan.customsDocumentNumber") }}</label>
                          <md-input v-model="form.customsDocumentNumber"></md-input>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-30">
                        <md-field>
                          <label>{{ $t("shippingPlan.customsAmount") }}</label>
                          <md-input v-model="form.customsAmount" type="text" inputmode="decimal" @blur="formatMoneyField('customsAmount')"></md-input>
                        </md-field>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <ValidationProvider name="supplierOrderId" rules="required" v-slot="{ errors }">
                      <md-field>
                        <label>{{ $t("shippingPlan.supplierOrderId") }}</label>
                        <md-input v-model="form.supplierOrderId"></md-input>
                        <div class="md-error" v-if="errors[0]">
                          {{ $t(errors[0]) }}
                        </div>
                      </md-field>
                    </ValidationProvider>
                    <ValidationProvider name="supplierName" rules="required" v-slot="{ errors }">
                      <div style="display: flex; align-items: flex-end; gap: 8px;" :class="{ 'has-error': errors[0] }">
                        <div style="flex: 1;">
                          <md-autocomplete v-model="supplierName" :md-options="supplierNamesOnly" :md-fuzzy-search="false">
                            <label>{{ $t("shippingPlan.supplierName") }}</label>
                          </md-autocomplete>
                        </div>
                        <md-button class="md-icon-button md-success md-raised" style="margin: 0 0 4px 0; min-width: 36px; width: 36px; height: 36px;" @click="createSupplierModal = true">
                          <md-icon>add</md-icon>
                        </md-button>
                      </div>
                    </ValidationProvider>
                    <date-picker v-model="form.prepaymentDateInput" format="YYYY-MM-DD" type="date" :placeholder="$t('shippingPlan.prepaymentDate')" style="width: 100%; margin: 15px 0"></date-picker>
                    <date-picker v-model="form.fullPaidDateInput" format="YYYY-MM-DD" type="date" :placeholder="$t('shippingPlan.fullPaidDate')" style="width: 100%"></date-picker>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label for="paymentStatus">{{ $t("shippingPlan.paymentStatus") }}</label>
                      <md-select v-model="form.paymentStatusId" name="paymentStatus" id="paymentStatus">
                        <md-option :key="i.id" v-for="i in paymentStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.paymentStatuses", i.name) }}</md-option>
                      </md-select>
                    </md-field>
                    <md-field>
                      <label>{{ $t("shippingPlan.orderTotalAmount") }}</label>
                      <md-input v-model="form.orderTotalAmount" type="text" inputmode="decimal" @blur="formatMoneyField('orderTotalAmount')"></md-input>
                    </md-field>
                    <md-field>
                      <label for="prepaymentAmount">{{ $t("shippingPlan.prepaymentAmount") }}</label>
                      <md-input v-model="form.prepaymentAmount" type="text" inputmode="decimal" @blur="formatMoneyField('prepaymentAmount')"></md-input>
                    </md-field>
                    <ValidationProvider name="exchangeRate" rules="decimal:4" v-slot="{ errors }">
                      <div class="exchange-rate-row">
                        <md-field :class="{ 'md-invalid': errors[0] }">
                          <label>{{ $t("shippingPlan.exchangeRate") }}</label>
                          <md-input v-model="form.exchangeRate" type="number" step="0.0001" min="0"></md-input>
                          <div class="md-error" v-if="errors[0]">{{ $t(errors[0]) }}</div>
                        </md-field>
                        <md-button
                          v-if="documentByType('commercial_invoice') || documentByType('proforma_invoice')"
                          class="md-icon-button md-info exchange-rate-btn"
                          :disabled="rateExtract.loading"
                          :title="$t('shippingPlan.exchangeRateAi')"
                          @click="extractRateFromDocument"
                        >
                          <md-icon v-if="rateExtract.loading">hourglass_top</md-icon>
                          <img v-else src="/img/ci-ai.png" alt="AI" />
                        </md-button>
                        <md-button class="md-icon-button md-success exchange-rate-btn" :title="$t('shippingPlan.exchangeRateLookup.button')" @click="openRateLookup">
                          <md-icon>event</md-icon>
                        </md-button>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="product-tab">
                  <div class="stock-update-status">
                    <strong>{{ $t("shippingPlan.stockUpdateStatus") }}</strong>
                    <div class="stock-update-status-row">
                      <span>
                        {{ $t("shippingPlan.wmsBooked") }}:
                        <span v-if="form.wmsGebucht" class="text-success material-symbols-outlined">check</span>
                        <span v-else class="text-danger material-symbols-outlined">close</span>
                      </span>
                      <span>
                        {{ $t("shippingPlan.afterbuyBooked") }}:
                        <span v-if="form.afterbuyGebucht" class="text-success material-symbols-outlined">check</span>
                        <span v-else class="text-danger material-symbols-outlined">close</span>
                      </span>
                    </div>
                    <small v-if="productsLocked" class="stock-update-status-hint">{{ $t("shippingPlan.wms.productsLockedHint") }}</small>
                  </div>
                  <div class="product-tab-header">
                    <span class="product-col-handle"></span>
                    <span class="product-col-qty">{{ $t("shippingPlan.quantityDelivering") }}</span>
                    <span class="product-col-sku">{{ $t("shippingPlan.product") }}</span>
                    <span class="product-col-ek">{{ $t("shippingPlan.purchasePrice") }}</span>
                    <span class="product-col-del"></span>
                  </div>
                  <draggable v-model="productTags" :disabled="productsLocked" handle=".product-handle" tag="div" class="product-tab-scroll">
                    <div v-for="tag in productTags" :key="tag.uid" class="product-tab-row">
                      <div class="product-col-handle">
                        <md-icon v-if="!productsLocked" class="product-handle">drag_indicator</md-icon>
                      </div>
                      <div class="product-col-qty">
                        <ValidationProvider :name="'qty_' + tag.uid" rules="required" v-slot="{ errors }">
                          <md-field :class="{ 'md-invalid': errors[0] }">
                            <md-input v-model="tag.count" type="number" min="1" :disabled="productsLocked"></md-input>
                          </md-field>
                        </ValidationProvider>
                      </div>
                      <div class="wrap-v-select product-col-sku">
                        <v-select
                          v-model="tag.skuObject"
                          label="sku"
                          :options="selectableProductSkuOptions"
                          :filter="fuseSearchSKU"
                          :placeholder="$t('shippingPlan.product')"
                          :append-to-body="true"
                          :disabled="productsLocked"
                        >
                          <template slot="no-options">{{ $t("noRecord") }}</template>
                          <template slot="option" slot-scope="option">
                            <div :class="option.exact ? 'exact' : ''">{{ option.sku }}</div>
                          </template>
                        </v-select>
                      </div>
                      <div class="product-col-ek product-col-ek-with-suffix">
                        <md-field>
                          <md-input v-model="tag.ek" type="text" inputmode="decimal" @blur="formatProductEk(tag)" :disabled="productsLocked"></md-input>
                        </md-field>
                        <span class="product-col-ek-suffix">$</span>
                      </div>
                      <div class="product-col-del">
                        <md-button v-if="!productsLocked" class="md-icon-button md-dense" @click="removeProduct(tag)" type="button"><md-icon>close</md-icon></md-button>
                      </div>
                    </div>
                  </draggable>
                  <div style="display:flex; gap:8px; margin-top:10px; align-items:center;">
                    <md-button class="md-success md-sm" @click="addInlineProductRow" :disabled="productsLocked">
                      <md-icon>add</md-icon>
                    </md-button>
                    <md-button class="md-warning md-sm" @click="createNewProductModal = true" :disabled="productsLocked">
                      {{ $t("shippingPlan.newProduct") }}
                    </md-button>
                    <md-button v-if="documentByType('commercial_invoice') || documentByType('proforma_invoice')" class="md-info md-sm ci-extract-btn" @click="openCiExtract" :disabled="productsLocked" :title="$t('shippingPlan.ciExtract.button')">
                      <img src="/img/ci-ai.png" alt="AI" />
                      {{ $t("shippingPlan.ciExtract.button") }}
                    </md-button>
                    <div v-if="productTags && productTags.length > 0" style="margin-left:auto; display:flex; gap:24px;">
                      <span><strong>{{ $t("shippingPlan.quantityDelivering") }}:</strong> {{ productTotalQuantity }}</span>
                      <span><strong>{{ $t("shippingPlan.purchasePrice") }}:</strong> {{ productTotalEk }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-4">
                <div class="documents-tab">
                  <div class="documents-upload-row">
                    <div
                      class="drop-zone"
                      :class="{ 'drop-zone--active': docUpload.dragOver }"
                      @dragover.prevent="docUpload.dragOver = true"
                      @dragleave="onDocumentDragLeave($event)"
                      @drop.prevent="onDocumentDrop($event)"
                      @click="$refs.docFile.click()"
                    >
                      <md-icon>cloud_upload</md-icon>
                      <span class="drop-zone-file">{{ docUpload.file ? docUpload.file.name : $t("shippingPlan.documentDropHint") }}</span>
                      <input ref="docFile" type="file" accept=".pdf" style="display: none" @change="onDocumentPicked($event)" />
                    </div>
                    <div class="wrap-v-select documents-type-col">
                      <v-select
                        class="custom-select"
                        label="label"
                        :options="documentTypeOptions"
                        :value="docUpload.type"
                        @input="docUpload.type = $event"
                        :clearable="false"
                        :append-to-body="true"
                        :placeholder="$t('shippingPlan.documentType')"
                      ></v-select>
                    </div>
                    <md-button class="md-success" :disabled="!docUpload.file || !docUpload.type || docUpload.saving" @click="saveDocument">
                      {{ $t("shippingPlan.save") }}
                    </md-button>
                  </div>
                  <!-- Upload laeuft durch pdftotext + KI-Extraktion und dauert spuerbar -
                       ohne sichtbare Rueckmeldung wird wild weitergeklickt -->
                  <div v-if="docUpload.saving" class="documents-upload-progress">
                    <md-progress-spinner md-mode="indeterminate" :md-diameter="24" :md-stroke="3"></md-progress-spinner>
                    <span>{{ $t("shippingPlan.documentUploading") }}</span>
                  </div>

                  <div class="document-tab-header">
                    <span>{{ $t("shippingPlan.documentName") }}</span>
                    <span class="document-col-checked">{{ $t("shippingPlan.documentChecked") }}</span>
                    <span>{{ $t("shippingPlan.documentType") }}</span>
                    <span>{{ $t("shippingPlan.table.actions") }}</span>
                  </div>
                  <div v-if="!documents.length" class="document-tab-empty">{{ $t("shippingPlan.noDocuments") }}</div>
                  <div v-for="d in documents" :key="d.id" class="document-tab-row">
                    <span class="document-col-name" :title="d.name">{{ d.name }}</span>
                    <span
                      class="document-col-checked"
                      :title="d.isChecked && d.checkedOn ? $t('shippingPlan.documentCheckedBy', { user: d.checkedBy || '–', date: $options.filters.formatDate(d.checkedOn) }) : ''"
                    >
                      <md-switch
                        :model="d.isChecked"
                        class="doc-check-switch"
                        :class="{ 'doc-check-switch--on': d.isChecked }"
                        :disabled="docChecking === d.id || !hasPermission('Write', 'ShippingPlans', 'Edit')"
                        @change="(val) => setDocumentChecked(d, val)"
                      ></md-switch>
                    </span>
                    <span>{{ $t("shippingPlan.documentTypes." + d.type) }}</span>
                    <span class="document-col-actions">
                      <md-button class="md-icon-button md-dense" :title="$t('shippingPlan.preview')" @click="previewDocument(d)">
                        <md-icon>visibility</md-icon>
                      </md-button>
                      <md-button class="md-icon-button md-dense" :title="$t('shippingPlan.delete')" @click="confirmDeleteDocument(d)">
                        <md-icon style="color: #f44336">delete</md-icon>
                      </md-button>
                    </span>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-5">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-50">
                    <div class="wrap-v-select mb-3 bearbeiter-col">
                      <label class="v-select-label">{{ $t("shippingPlan.chinaUser") }}</label>
                      <v-select
                        :options="chinaUserOptions"
                        :value="chinaUserOptions.find(i => i.id === form.chinaUser)"
                        @input="val => form.chinaUser = val ? val.id : null"
                        label="name"
                        :clearable="true"
                      >
                        <template #option="option">
                          <user-avatar :user-id="option.id" style="width:20px;height:20px;border-radius:50%;vertical-align:middle;margin-right:6px;object-fit:cover" />
                          {{ option.name }}
                        </template>
                        <template #selected-option="option">
                          <user-avatar :user-id="option.id" style="width:20px;height:20px;border-radius:50%;vertical-align:middle;margin-right:6px;object-fit:cover" />
                          {{ option.name }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label for="chinaStatus">{{ $t("shippingPlan.chinaStatus") }}</label>
                      <md-select v-model="form.chinaStatusId" name="chinaStatus" id="chinaStatus">
                        <md-option :key="i.id" v-for="i in chinaStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.chinaStatuses", i.name) }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label for="chinaText">{{ $t("shippingPlan.chinaText") }}</label>
                      <md-textarea v-model="form.chinaText" md-autogrow></md-textarea>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label for="mtcStatus">{{ $t("shippingPlan.mtcStatus") }}</label>
                      <md-select v-model="form.mtcStatus" name="mtcStatus" id="mtcStatus">
                        <md-option value="pending">{{ $t("shippingPlan.documentStatuses.pending") }}</md-option>
                        <md-option value="requested">{{ $t("shippingPlan.documentStatuses.requested") }}</md-option>
                        <md-option value="received">{{ $t("shippingPlan.documentStatuses.received") }}</md-option>
                        <md-option value="forwarded">{{ $t("shippingPlan.documentStatuses.forwarded") }}</md-option>
                        <md-option value="not_needed">{{ $t("shippingPlan.documentStatuses.not_needed") }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label for="coStatus">{{ $t("shippingPlan.coStatus") }}</label>
                      <md-select v-model="form.coStatus" name="coStatus" id="coStatus">
                        <md-option value="pending">{{ $t("shippingPlan.documentStatuses.pending") }}</md-option>
                        <md-option value="requested">{{ $t("shippingPlan.documentStatuses.requested") }}</md-option>
                        <md-option value="received">{{ $t("shippingPlan.documentStatuses.received") }}</md-option>
                        <md-option value="forwarded">{{ $t("shippingPlan.documentStatuses.forwarded") }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-6">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label for="accountingStatusId">{{ $t("shippingPlan.accountingStatus") }}</label>
                      <md-select v-model="form.accountingStatusId" name="accountingStatusId" id="accountingStatusId">
                        <md-option :key="i.id" v-for="i in accountingStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.accountingStatuses", i.name) }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <date-picker
                      v-model="form.accountingStatusDateInput"
                      format="YYYY-MM-DD"
                      type="date"
                      :placeholder="$t('shippingPlan.accountingStatusDate')"
                      style="width: 100%; margin: 15px 0"
                    ></date-picker>
                  </div>
                </div>
              </template>
            </tabs>
          </ValidationObserver>
        </template>
        <template slot="footer">
          <md-button class="md-secondary mr-1" @click="hideEditModal">{{ $t("shippingPlan.close") }}</md-button>
          <md-button class="md-success" @click="editShipppingPlan">{{ $t("shippingPlan.save") }}</md-button>
        </template>
      </modal>

      <modal v-if="createModal" @close="hideCreateModal" class-name="shipping-plan-modal-container">
        <template slot="header">
          <h4 class="modal-title">
            {{ $t("shippingPlan.createShippingPlan") }}
          </h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideCreateModal">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <ValidationObserver v-slot="{}" ref="createForm">
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <ValidationProvider name="shipmentRecordName" rules="required" v-slot="{ errors }">
                  <md-field>
                    <label>{{ $t("shippingPlan.shipmentRecordName") }}</label>
                    <md-input v-model="shipmentRecordName"></md-input>
                    <div class="md-error" v-if="errors[0]">
                      {{ $t(errors[0]) }}
                    </div>
                  </md-field>
                </ValidationProvider>
                <ValidationProvider name="supplierName" rules="required" v-slot="{ errors }">
                  <div style="display: flex; align-items: flex-end; gap: 8px;">
                    <div style="flex: 1;">
                      <md-autocomplete v-model="supplierName" :md-options="supplierNamesOnly" :md-fuzzy-search="false">
                        <label>{{ $t("shippingPlan.supplierName") }}</label>
                      </md-autocomplete>
                    </div>
                    <md-button class="md-icon-button md-success md-raised" style="margin: 0 0 4px 0; min-width: 36px; width: 36px; height: 36px;" @click="createSupplierModal = true">
                      <md-icon>add</md-icon>
                    </md-button>
                  </div>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-50">
                <ValidationProvider name="supplierOrderId" rules="required" v-slot="{ errors }">
                  <md-field>
                    <label>{{ $t("shippingPlan.supplierOrderId") }}</label>
                    <md-input v-model="supplierOrderId"></md-input>
                    <div class="md-error" v-if="errors[0]">
                      {{ $t(errors[0]) }}
                    </div>
                  </md-field>
                </ValidationProvider>
                <p class="date-title">
                  {{ $t("shippingPlan.containerArrivalDate") }}
                </p>
                <date-time-picker :startDate="containerArrivalDateInput" :singleDate="true" @onChange="(d) => (containerArrivalDateInput = d.startDate)" class="datetime-input" timeFormat="HH:mm" />
              </div>
            </div>
          </ValidationObserver>
        </template>
        <template slot="footer">
          <md-button class="md-secondary mr-1" @click="hideCreateModal">{{ $t("shippingPlan.close") }}</md-button>
          <md-button class="md-success" @click="createShipppingPlan">{{ $t("shippingPlan.save") }}</md-button>
        </template>
      </modal>

      <modal v-if="historicalModal" @close="hideHistoricalModal" class-name="historical-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.historical") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideHistoricalModal">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <Historical2 :shipmentRecordId="currentShipmentRecordId"></Historical2>
        </template>
        <template slot="footer"> </template>
      </modal>

      <modal v-if="deleteModal" @close="hideDelete" class-name="orders-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.delete.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideDelete">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <p>{{ $t("shippingPlan.delete.confirm", { name: deleteRow && deleteRow.shipmentRecordName }) }}</p>
          <p class="text-muted" style="font-size: 13px">{{ $t("shippingPlan.delete.historyHint") }}</p>
        </template>
        <template slot="footer">
          <md-button class="md-simple" @click="hideDelete">{{ $t("shippingPlan.cancel") }}</md-button>
          <md-button class="md-danger" :disabled="isDeleting" @click="doDelete">{{ $t("shippingPlan.delete.confirmButton") }}</md-button>
        </template>
      </modal>

      <modal v-if="wmsBookingModal" @close="hideWmsBooking" class-name="shipping-plan-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.wms.bookTitle") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideWmsBooking">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div v-if="wmsBookingLoading" class="text-center" style="padding: 24px">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="40"></md-progress-spinner>
          </div>
          <div v-else-if="wmsBookingPreview">
            <p v-if="wmsBookingPreview.alreadyBooked" class="text-danger">
              {{ $t("shippingPlan.wms.alreadyBooked") }}
            </p>
            <template v-if="!wmsBookingPreview.hasExchangeRate">
              <p class="text-danger">
                {{ $t("shippingPlan.wms.noExchangeRate") }}
              </p>
              <div v-if="!wmsBookingPreview.alreadyBooked" class="exchange-rate-row wms-rate-row">
                <md-field>
                  <label>{{ $t("shippingPlan.exchangeRate") }}</label>
                  <md-input v-model="wmsRate.value" type="number" step="0.0001" min="0"></md-input>
                </md-field>
                <md-button
                  v-if="wmsBookingPreview.rateDocument"
                  class="md-icon-button md-info exchange-rate-btn"
                  :disabled="wmsRate.extracting"
                  :title="$t('shippingPlan.exchangeRateAi')"
                  @click="wmsExtractRate"
                >
                  <md-icon v-if="wmsRate.extracting">hourglass_top</md-icon>
                  <img v-else src="/img/ci-ai.png" alt="AI" />
                </md-button>
                <md-button class="md-icon-button md-success exchange-rate-btn" :title="$t('shippingPlan.exchangeRateLookup.button')" @click="openRateLookup('wms')">
                  <md-icon>event</md-icon>
                </md-button>
                <md-button class="md-success md-sm wms-rate-save" :disabled="!wmsRateValid || wmsRate.saving" @click="saveWmsRate">
                  {{ $t("shippingPlan.wms.saveRate") }}
                </md-button>
              </div>
            </template>
            <p v-else-if="!wmsBookingPreview.storageLocationId" class="text-danger">
              {{ $t("shippingPlan.wms.noWarehouse") }}
            </p>
            <p v-else-if="!wmsBookingPreview.rows || wmsBookingPreview.rows.length === 0" class="text-danger">
              {{ $t("shippingPlan.wms.noProducts") }}
            </p>
            <table v-if="wmsBookingPreview.rows && wmsBookingPreview.rows.length" class="wms-booking-table">
              <thead>
                <tr>
                  <th>{{ $t("shippingPlan.wms.storageLocation") }}</th>
                  <th>{{ $t("shippingPlan.wms.sku") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.wms.quantity") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.wms.ek") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.wms.customs") }}</th>
                  <th>{{ $t("shippingPlan.wms.source") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in wmsBookingPreview.rows" :key="i">
                  <td>{{ r.storageLocation }}</td>
                  <td>{{ r.sku }}</td>
                  <td class="text-right">{{ r.quantity }}</td>
                  <td class="text-right">{{ r.ek != null ? formatMoney(r.ek) + " $" : "–" }}</td>
                  <td class="text-right">{{ formatMoney(r.customs || 0) + " €" }}</td>
                  <td>{{ r.source }}</td>
                </tr>
              </tbody>
            </table>
            <p v-if="wmsBookingPreview.hasExchangeRate" class="wms-booking-rate">
              {{ $t("shippingPlan.exchangeRate") }}: {{ formatRate(wmsBookingPreview.exchangeRate) }}
            </p>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-simple" @click="hideWmsBooking">{{ $t("shippingPlan.cancel") }}</md-button>
          <md-button class="md-success" :disabled="!canConfirmWmsBooking || wmsBookingSubmitting" @click="confirmWmsBooking">{{ $t("shippingPlan.save") }}</md-button>
        </template>
      </modal>

      <modal v-if="afterbuyBookingModal" @close="hideAfterbuyBooking" class-name="shipping-plan-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.afterbuy.bookTitle") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideAfterbuyBooking">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div v-if="afterbuyBookingLoading" class="text-center" style="padding: 24px">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="40"></md-progress-spinner>
          </div>
          <div v-else-if="afterbuyBookingPreview">
            <p v-if="!afterbuyBookingPreview.rows || afterbuyBookingPreview.rows.length === 0" class="text-danger">
              {{ $t("shippingPlan.afterbuy.noProducts") }}
            </p>
            <p v-else-if="!afterbuyBookingPreview.allFound" class="text-danger">
              {{ $t("shippingPlan.afterbuy.notAllFound") }}
            </p>
            <table v-if="afterbuyBookingPreview.rows && afterbuyBookingPreview.rows.length" class="wms-booking-table">
              <thead>
                <tr>
                  <th class="text-right">{{ $t("shippingPlan.afterbuy.quantity") }}</th>
                  <th>{{ $t("shippingPlan.afterbuy.sku") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.afterbuy.afterbuyStock") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.afterbuy.auctionStock") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.afterbuy.newStock") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in afterbuyBookingPreview.rows" :key="i">
                  <td class="text-right">{{ r.quantity }}</td>
                  <td>{{ r.sku }}</td>
                  <td class="text-right"><span v-if="r.found">{{ r.afterbuyStock }}</span><span v-else class="text-danger">n/a</span></td>
                  <td class="text-right"><span v-if="r.found">{{ r.auctionStock }}</span><span v-else class="text-danger">n/a</span></td>
                  <td class="text-right"><span v-if="r.found">{{ r.newAfterbuyStock }}</span><span v-else class="text-danger">n/a</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-simple" @click="hideAfterbuyBooking">{{ $t("shippingPlan.cancel") }}</md-button>
          <md-button class="md-success" :disabled="!canConfirmAfterbuyBooking || afterbuyBookingSubmitting" @click="confirmAfterbuyBooking">{{ $t("shippingPlan.save") }}</md-button>
        </template>
      </modal>

      <CreateProductModal v-if="createNewProductModal" @close="createNewProductModal = false" @saved="onNewProductSaved" />

      <record-tag-manager v-if="recordTagManager" @close="recordTagManager = false" @changed="onRecordTagChanged" />
      <modal v-if="createSupplierModal" @close="createSupplierModal = false">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.newSupplier") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="createSupplierModal = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <md-field>
            <label>{{ $t("shippingPlan.supplierName") }}</label>
            <md-input v-model="newSupplierName"></md-input>
          </md-field>
        </template>
        <template slot="footer">
          <md-button class="md-success" @click="createSupplierInline">{{ $t("shippingPlan.save") }}</md-button>
        </template>
      </modal>

      <modal v-if="splitModal" @close="hideSplitModal" class-name="split-orders-modal-container modal-fullscreen">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.split.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideSplitModal">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <ShippingPlanSplit :source="splitSource" :options="splitOptions" @close="hideSplitModal" @saved="afterSplit" />
        </template>
      </modal>

      <modal v-if="freightConfirm.show" @close="freightConfirm.show = false" class-name="freight-confirm-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.freightExtract.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="freightConfirm.show = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <p v-if="freightConfirm.error" class="freight-confirm-hint">{{ $t("shippingPlan.freightExtract.notRecognized") }}</p>
          <p v-else class="freight-confirm-hint">{{ $t("shippingPlan.freightExtract.checkHint") }}</p>
          <md-field>
            <label>{{ $t("shippingPlan.shipmentDocumentNumber") }}</label>
            <md-input v-model="freightConfirm.documentNumber" type="text"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t("shippingPlan.shipmentAmount") }}</label>
            <md-input v-model="freightConfirm.amount" type="text" inputmode="decimal"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t("shippingPlan.shipmentPaidStatus") }}</label>
            <md-select v-model="freightConfirm.paidStatusId">
              <md-option v-for="o in shipmentPaidStatusOptions" :key="o.id" :value="o.id">{{ o.name }}</md-option>
            </md-select>
          </md-field>
        </template>
        <template slot="footer">
          <md-button class="md-secondary mr-1" @click="freightConfirm.show = false">{{ $t("shippingPlan.freightExtract.discard") }}</md-button>
          <md-button class="md-success" @click="applyFreightConfirm">{{ $t("shippingPlan.freightExtract.apply") }}</md-button>
        </template>
      </modal>

      <modal v-if="rateLookup.show" @close="rateLookup.show = false" class-name="rate-lookup-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.exchangeRateLookup.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="rateLookup.show = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <md-field>
            <label>{{ $t("shippingPlan.exchangeRateLookup.date") }}</label>
            <md-input v-model="rateLookup.date" type="date" @change="lookupRate"></md-input>
          </md-field>
          <div class="rate-lookup-result">
            <md-progress-spinner v-if="rateLookup.loading" md-mode="indeterminate" :md-diameter="24" :md-stroke="3"></md-progress-spinner>
            <span v-else-if="rateLookup.error" class="text-danger">{{ $t("shippingPlan.exchangeRateLookup.error") }}</span>
            <span v-else-if="rateLookup.rate">
              {{ $t("shippingPlan.exchangeRateLookup.result", { rate: formatRate(rateLookup.rate), date: $options.filters.formatDate(rateLookup.rateDate) }) }}
            </span>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-secondary mr-1" @click="rateLookup.show = false">{{ $t("shippingPlan.cancel") }}</md-button>
          <md-button class="md-success" :disabled="!rateLookup.rate" @click="applyLookupRate">{{ $t("shippingPlan.exchangeRateLookup.apply") }}</md-button>
        </template>
      </modal>

      <modal v-if="customsConfirm.show" @close="customsConfirm.show = false" class-name="freight-confirm-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.customsExtract.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="customsConfirm.show = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <p v-if="customsConfirm.error" class="freight-confirm-hint">{{ $t("shippingPlan.customsExtract.notRecognized") }}</p>
          <p v-else class="freight-confirm-hint">{{ $t("shippingPlan.customsExtract.checkHint") }}</p>
          <md-field>
            <label>{{ $t("shippingPlan.customsDocumentNumber") }}</label>
            <md-input v-model="customsConfirm.documentNumber" type="text"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t("shippingPlan.customsAmount") }}</label>
            <md-input v-model="customsConfirm.amount" type="text" inputmode="decimal"></md-input>
          </md-field>
          <md-field>
            <label>{{ $t("shippingPlan.customsPaidStatus") }}</label>
            <md-select v-model="customsConfirm.paidStatusId">
              <md-option v-for="o in customsPaidStatusOptions" :key="o.id" :value="o.id">{{ o.name }}</md-option>
            </md-select>
          </md-field>
        </template>
        <template slot="footer">
          <md-button class="md-secondary mr-1" @click="customsConfirm.show = false">{{ $t("shippingPlan.customsExtract.discard") }}</md-button>
          <md-button class="md-success" @click="applyCustomsConfirm">{{ $t("shippingPlan.customsExtract.apply") }}</md-button>
        </template>
      </modal>

      <modal v-if="freightAllocation.show" @close="freightAllocation.show = false" class-name="freight-allocation-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.freightAllocation.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="freightAllocation.show = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div v-if="freightAllocation.loading" class="text-center" style="padding: 24px">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="40"></md-progress-spinner>
          </div>
          <div v-else-if="freightAllocation.error" class="freight-allocation-warning">
            {{ $t("shippingPlan.freightAllocation.errors." + freightAllocation.error, { containerId: freightAllocation.containerId }) }}
          </div>
          <div v-else>
            <p class="freight-confirm-hint">{{ $t("shippingPlan.freightAllocation.hint") }}</p>
            <p class="freight-allocation-meta">
              {{ $t("shippingPlan.containerId") }}: <strong>{{ freightAllocation.containerId }}</strong> ·
              {{ $t("shippingPlan.freightAllocation.amount") }}:
              <input
                v-model="freightAllocation.amountInput"
                type="text"
                inputmode="decimal"
                class="freight-allocation-input freight-allocation-amount"
                @change="reloadFreightAllocation"
              />
              € ·
              {{ $t("shippingPlan.freightAllocation.totalVolume") }}: <strong>{{ formatVolume(freightAllocation.totalVolume) }} cbm</strong>
            </p>
            <div v-if="freightAllocation.skusWithoutVolume.length" class="freight-allocation-warning">
              {{ $t("shippingPlan.freightAllocation.missingVolumes") }}: {{ freightAllocation.skusWithoutVolume.join(", ") }}
            </div>
            <table class="wms-booking-table">
              <thead>
                <tr>
                  <th>{{ $t("shippingPlan.wms.sku") }}</th>
                  <th>{{ $t("shippingPlan.wms.storageLocation") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.freightAllocation.inventory") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.freightAllocation.plannedQuantity") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.freightAllocation.unitVolume") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.freightAllocation.currentBznk") }}</th>
                  <th class="text-right">{{ $t("shippingPlan.freightAllocation.proposal") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in freightAllocation.rows" :key="r.inventoryId">
                  <td>{{ r.sku }}</td>
                  <td>{{ r.storageLocation }}</td>
                  <td class="text-right">{{ r.inventory }}</td>
                  <td class="text-right">{{ r.plannedQuantity != null ? r.plannedQuantity : "–" }}</td>
                  <td class="text-right">{{ r.unitVolume != null ? formatVolume(r.unitVolume) + " cbm" : "–" }}</td>
                  <td class="text-right">{{ formatMoney(r.currentBznk) }} €</td>
                  <td class="text-right">
                    <input v-model="r.bznk" type="text" inputmode="decimal" class="freight-allocation-input" @blur="formatAllocationRow(r)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-secondary mr-1" @click="freightAllocation.show = false">{{ $t("shippingPlan.freightAllocation.discard") }}</md-button>
          <md-button v-if="!freightAllocation.error" class="md-success" :disabled="freightAllocation.loading || freightAllocation.saving" @click="applyFreightAllocation">
            {{ $t("shippingPlan.freightAllocation.apply") }}
          </md-button>
        </template>
      </modal>

      <modal v-if="pdfModal.show" @close="closePdfModal" class-name="pdf-preview-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ pdfModal.title }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closePdfModal">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <iframe v-if="pdfModal.url" :src="pdfModal.url" style="width:100%;height:75vh;border:none;"></iframe>
          <div v-else style="height:75vh;display:flex;align-items:center;justify-content:center;">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-primary" :href="pdfModal.url" :download="pdfModal.title" tag="a" :disabled="!pdfModal.url">
            <md-icon>download</md-icon> {{ $t("shippingPlan.download") }}
          </md-button>
          <md-button class="md-secondary" @click="closePdfModal">{{ $t("shippingPlan.close") }}</md-button>
        </template>
      </modal>

      <modal v-if="ciExtract.modal" @close="closeCiExtract" class-name="ci-extract-modal-container">
        <template slot="header">
          <h4 class="modal-title">{{ $t("shippingPlan.ciExtract.title") }}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeCiExtract">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div class="ci-extract-layout">
            <div v-if="ciExtract.pdfUrl" class="ci-extract-pdf">
              <iframe :src="ciExtract.pdfUrl"></iframe>
            </div>
            <div class="ci-extract-content">
          <div v-if="ciExtract.choose" style="min-height:220px;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;">
            <span>{{ $t("shippingPlan.ciExtract.chooseDocument") }}</span>
            <div style="display:flex;gap:12px;">
              <md-button class="md-success" @click="loadCiExtract('ci')">{{ $t("shippingPlan.commercialInvoice") }}</md-button>
              <md-button class="md-info" @click="loadCiExtract('pi')">{{ $t("shippingPlan.proformaInvoice") }}</md-button>
            </div>
          </div>
          <div v-else-if="ciExtract.loading" style="min-height:220px;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            <span>{{ $t("shippingPlan.ciExtract.loading") }}</span>
          </div>
          <div v-else-if="ciExtract.error" style="min-height:120px;display:flex;align-items:center;justify-content:center;">
            <span class="text-danger">{{ $t("shippingPlan.ciExtract.errors." + ciExtract.error) }}</span>
          </div>
          <div v-else>
            <div v-if="ciExtract.invoiceDate || ciExtract.exchangeRate" class="ci-meta">
              <span v-if="ciExtract.invoiceDate"><strong>{{ $t("shippingPlan.ciExtract.invoiceDate") }}:</strong> {{ ciExtract.invoiceDate | formatDate }}</span>
              <span v-if="ciExtract.exchangeRate"><strong>{{ $t("shippingPlan.ciExtract.rate") }}</strong> <template v-if="ciExtract.exchangeRateDate">{{ ciExtract.exchangeRateDate | formatDate }}</template>: {{ formatRate(ciExtract.exchangeRate) }} $/€</span>
              <md-checkbox v-if="ciExtract.exchangeRate" v-model="ciExtract.applyRate" class="ci-rate-checkbox">{{ $t("shippingPlan.ciExtract.applyRate") }}</md-checkbox>
            </div>
            <table class="ci-extract-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{{ $t("shippingPlan.quantityDelivering") }}</th>
                  <th>{{ $t("shippingPlan.product") }}</th>
                  <th>{{ $t("shippingPlan.purchasePrice") }}</th>
                  <th>{{ $t("shippingPlan.ciExtract.invoiceText") }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in ciExtract.rows" :key="r.uid">
                  <td><span class="ci-dot" :class="'ci-dot--' + rowAmpel(r)" :title="$t('shippingPlan.ciExtract.status.' + rowAmpel(r))"></span></td>
                  <td class="ci-col-qty">
                    <md-field class="ci-field"><md-input v-model="r.count" type="number" min="1"></md-input></md-field>
                  </td>
                  <td class="wrap-v-select ci-col-sku">
                    <!-- Auswahl nur Neuware (Karte 24.08.): B-Ware darf hier nicht zugeordnet werden.
                         Die Vorbefuellung aus der CI-Extraktion bleibt bewusst ungefiltert. -->
                    <v-select v-model="r.skuObject" label="sku" :options="selectableProductSkuOptions" :filter="fuseSearchSKU" :append-to-body="true" :placeholder="$t('shippingPlan.product')">
                      <template slot="no-options">{{ $t("noRecord") }}</template>
                      <template slot="option" slot-scope="option">
                        <div :class="option.exact ? 'exact' : ''">{{ option.sku }}</div>
                      </template>
                    </v-select>
                  </td>
                  <td class="ci-col-ek">
                    <md-field class="ci-field"><md-input v-model="r.ek" type="text" inputmode="decimal" @blur="formatProductEk(r)"></md-input></md-field>
                    <span>$</span>
                  </td>
                  <td class="ci-raw" :title="[r.skuRaw, r.description].filter(Boolean).join(' — ')">{{ [r.skuRaw, r.description].filter(Boolean).join(" — ") }}</td>
                  <td><md-button class="md-icon-button md-dense" @click="removeCiRow(r)" type="button"><md-icon>close</md-icon></md-button></td>
                </tr>
              </tbody>
            </table>
            <div v-if="!ciExtract.rows.length" style="padding:24px;text-align:center;">{{ $t("shippingPlan.ciExtract.empty") }}</div>
            <small v-else class="ci-legend">{{ $t("shippingPlan.ciExtract.legend") }}</small>
          </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-secondary" @click="closeCiExtract">{{ $t("shippingPlan.close") }}</md-button>
          <md-button class="md-success" :disabled="ciExtract.loading || !!ciExtract.error || applicableCiRows === 0" @click="applyCiRows">
            {{ $t("shippingPlan.ciExtract.apply") }} ({{ applicableCiRows }})
          </md-button>
        </template>
      </modal>
    </div>

    <div class="sp-dock">
      <a v-if="hasPermission('Write', 'ShippingPlans', 'Create')" class="sp-dock-trigger" :title="$t('shippingPlan.createShippingPlan')" @click="openCreateModal">
        <md-icon>add</md-icon>
      </a>
      <div class="sp-dock-search">
        <a class="sp-dock-trigger" :class="{ 'sp-dock-trigger--active': filter.keywords }" @click="toggleDockSearch">
          <md-icon>search</md-icon>
        </a>
        <div v-show="dockSearchOpen" class="sp-dock-search-panel">
          <md-field md-clearable>
            <label>{{ $t("shippingPlan.keywords") }}</label>
            <md-input ref="dockSearchInput" v-model="filter.keywords" @input="debounceApplyFilters"></md-input>
          </md-field>
        </div>
      </div>
      <drawer-filter ref="drawerFilter" @apply-filters="applyFilters"> </drawer-filter>
    </div>
    <div class="sp-dock-info" :class="{ 'sp-dock-info--collapsed': summaryCollapsed }">
      <!-- Einklappbar auf Kundenwunsch (Trello 20.08., 1:1 wie im Bestellwesen) -->
      <a class="sp-dock-info-toggle" :title="$t(summaryCollapsed ? 'procurement.summary.expand' : 'procurement.summary.collapse')" @click="summaryCollapsed = !summaryCollapsed">
        <md-icon>{{ summaryCollapsed ? "expand_less" : "expand_more" }}</md-icon>
      </a>
      <template v-if="!summaryCollapsed">
        <md-switch v-model="includeArchived" @change="onIncludeArchivedChange" class="md-primary">{{ $t("shippingPlan.includeArchived") }}</md-switch>
        <div class="sp-dock-info-row">
          <span>{{ $t("shippingPlan.filtered") }} / {{ $t("shippingPlan.total") }}</span>
          <strong>{{ tableData.length }} / {{ totalItems }}</strong>
        </div>
        <div class="sp-dock-info-row">
          <span>{{ $t("shippingPlan.table.totalAmount") }}</span>
          <strong>{{ (footerOrderTotalAmount || 0) | formatAmount }}</strong>
        </div>
        <div class="sp-dock-info-row">
          <span>{{ $t("shippingPlan.table.prepayment") }}</span>
          <strong>{{ (footerPrepaymentAmount || 0) | formatAmount }}</strong>
        </div>
        <div class="sp-dock-info-row">
          <span>{{ $t("shippingPlan.table.finalPayment") }}</span>
          <strong>{{ (footerOpenAmount || 0) | formatAmount }}</strong>
        </div>
      </template>
    </div>

    <md-dialog-confirm
      :md-active.sync="forceReleaseDialog"
      :md-title="$t('shippingPlan.messages.forceReleaseTitle')"
      :md-content="forceReleaseMessage"
      :md-confirm-text="$t('shippingPlan.messages.forceReleaseConfirm')"
      :md-cancel-text="$t('shippingPlan.messages.forceReleaseCancel')"
      @md-confirm="doForceRelease"
    />
  </div>
</template>
<script>
import { forEach, debounce, sumBy, sum, remove, uniqBy } from "lodash";
import { format, formatISO } from "date-fns";
import Fuse from "fuse.js";
import RecordTagSelect from "./RecordTagSelect.vue";
import RecordTagManager from "./RecordTagManager.vue";
import { DateTimePicker } from "@lazy-copilot/datetimepicker";
import DatePicker from "vue2-datepicker";
import numeral from "numeral";

import { Tabs } from "@/components";
import ShippingPlanSplit from "@/components/ShippingPlans/ShippingPlanSplit.vue";
import { Modal, UserAvatar } from "@/components";
import RecordTag from "./RecordTag.vue";
import DrawerFilter from "./DrawerFilter.vue";
import Historical2 from "./Historical2.vue";
import CarrierInfo from "./CarrierInfo.vue";
import DestinationInfo from "./DestinationInfo.vue";
import CSLoading from "../../components/Loading/CSLoading.vue";
import axiosFactory from "../../services/axios.factory";
import TokenService from "../../services/token.service";
import config from "../../config";
import * as signalR from "@microsoft/signalr";
import { EventBus } from "@/helpers/event-bus";
import stickyTableHeader from "@/helpers/stickyTableHeader";
import { hasPermission, isAdmin } from "../../mixins/auth";
import { normalizeStatusName } from "../../mixins/formats";
import CreateProductModal from "../Products/CreateProductModal.vue";
import draggable from "vuedraggable";
import HoverTip from "@/components/HoverTip/HoverTip.vue";
import hoverTip from "@/components/HoverTip/hoverTipDirective";

export default {
  directives: { hoverTip },
  components: {
    HoverTip,
    Tabs,
    Modal,
    ShippingPlanSplit,
    UserAvatar,
    RecordTagSelect,
    RecordTagManager,
    RecordTag,
    DrawerFilter,
    CSLoading,
    Historical2,
    CarrierInfo,
    DestinationInfo,
    DateTimePicker,
    DatePicker,
    CreateProductModal,
    draggable,
  },
  data() {
    return {
      isLoading: true,
      includeArchived: false,
      summaryCollapsed: false,
      footerOrderTotalAmount: 0,
      footerPrepaymentAmount: 0,
      footerOpenAmount: 0,
      editModal: false,
      splitModal: false,
      splitSource: null,
      createModal: false,
      forceReleaseDialog: false,
      forceReleaseTarget: null,
      historicalModal: false,
      pdfModal: { show: false, url: '', title: '' },
      ciExtract: { modal: false, loading: false, choose: false, rows: [], error: null, counts: null, pdfUrl: null, invoiceDate: null, exchangeRate: null, exchangeRateDate: null, applyRate: false },
      rateExtract: { loading: false },
      rateLookup: { show: false, date: null, loading: false, rate: null, rateDate: null, error: null, target: "form" },
      wmsRate: { value: null, extracting: false, saving: false },
      sdate: null,
      documents: [],
      docChecking: null,
      docUpload: { file: null, type: null, dragOver: false, saving: false },
      freightConfirm: { show: false, error: null, documentNumber: null, amount: null, paidStatusId: null },
      customsConfirm: { show: false, error: null, documentNumber: null, amount: null, paidStatusId: null },
      freightAllocation: { show: false, loading: false, saving: false, containerId: null, amount: null, totalVolume: null, skusWithoutVolume: [], rows: [] },
      shipmentRecordName: null,
      supplierOrderId: null,
      supplierName: null,
      createSupplierModal: false,
      newSupplierName: null,
      containerArrivalDateInput: new Date(),
      containerArrivalDateFixed: false,
      containerArrivalDatePlanned: false,
      containerArrivalDateProvisional: false,
      containerArrivalDateType: null,
      isFilter: false,
      tags: [],
      recordTagManager: false,
      productTag: "",
      productTags: [],
      productTagSeq: 0,
      createNewProductModal: false,
      currentShipmentRecordId: null,
      deleteModal: false,
      deleteRow: null,
      isDeleting: false,
      wmsBookingModal: false,
      wmsBookingLoading: false,
      wmsBookingPreview: null,
      wmsBookingRecordId: null,
      afterbuyBookingModal: false,
      afterbuyBookingLoading: false,
      afterbuyBookingPreview: null,
      afterbuyBookingRecordId: null,
      afterbuyBookingSubmitting: false,
      wmsBookingSubmitting: false,
      form: {
        shipmentRecordId: null,
        recordStatusId: null,
        recordTags: null,
        shipmentNote: null,
        shipmentRecordName: null,
        linkedProductIds: null,
        supplierOrderId: null,
        supplierNameId: null,
        containerId: null,
        containerSizeId: null,
        containerArrivalDate: null,
        containerArrivalDateFixed: false,
        containerArrivalDatePlanned: false,
        containerArrivalDateProvisional: false,
        containerArrivalPlaceId: null,
        productDataSent: false,
        containerBookingStatus: "pending",
        mtcStatus: "pending",
        coStatus: "pending",
        containerBookingDateInput: null,
        carrierShipmentId: null,
        trackingUrl: null,
        carrierNameId: null,
        paymentStatusId: null,
        orderTotalAmount: null,
        prepaymentAmount: null,
        prepaymentDate: null,
        fullpaidDate: null,
        shipmentPaidStatusId: null,
        shipmentDocumentNumber: null,
        shipmentAmount: null,
        customsPaidStatusId: null,
        customsDocumentNumber: null,
        customsAmount: null,
        chinaStatusId: null,
        chinaText: null,
        chinaUser: null,
        accountingStatusId: null,
        accountingStatusDate: null,
        exchangeRate: null,
        wmsGebucht: false,
        afterbuyGebucht: false,

        proformaInvoice: null,
        commercialInvoice: null,
        packingList: null,

        containerArrivalDateInput: null,
        prepaymentDateInput: null,
        fullPaidDateInput: null,
        accountingStatusDateInput: null,
      },
      filter: {
        keywords: null,
      },
      tableColumns: ["actions", "status", "notes", "supplier", "shipment", "documents", "arrival", "items", "china", "payment", "freight", "accounting"],
      tableOptions: {
        headings: {
          actions: () => this.$t("shippingPlan.table.actions"),
          status: () => this.$t("shippingPlan.table.status"),
          notes: () => this.$t("shippingPlan.table.notes"),
          supplier: () => this.$t("shippingPlan.table.supplier"),
          shipment: () => this.$t("shippingPlan.table.shipment"),
          documents: () => this.$t("shippingPlan.table.documents"),
          arrival: () => this.$t("shippingPlan.table.arrival"),
          items: () => this.$t("shippingPlan.table.items"),
          china: () => this.$t("shippingPlan.table.china"),
          payment: () => this.$t("shippingPlan.table.payment"),
          freight: () => this.$t("shippingPlan.table.freight"),
          accounting: () => this.$t("shippingPlan.table.accounting"),
        },
        perPage: 0,
        perPageValues: [0],
        filterable: false,
        sortable: [],
        params: { excludeArchived: true },
        resizableColumns: false,
        requestFunction: this.requestFunction,
        responseAdapter: this.responseFunction,
        rowClassCallback: this.rowClassCallback,
        columnsClasses: {
          notes: "td-shipping-plan td-notes",
          documents: "td-shipping-plan td-documents",
          items: "td-shipping-plan td-items",
          china: "td-shipping-plan td-china",
          payment: "td-shipping-plan td-payment",
          freight: "td-shipping-plan td-freight",
          accounting: "td-shipping-plan td-accounting",
        },
        pagination: {
          show: false,
        },
        texts: {
          count: this.$t("table.count"),
          limit: this.$t("table.records"),
          noResults: this.$t("table.noRecord"),
        },
      },
      tableData: [],
      totalItems: 0,
      dockSearchOpen: false,
      didInitialScroll: false,
    };
  },
  computed: {
    forceReleaseMessage() {
      const row = this.forceReleaseTarget;
      if (!row) return "";
      const key = row.blockedActive ? "shippingPlan.messages.forceReleaseActive" : "shippingPlan.messages.forceReleaseStale";
      return this.$t(key, {
        user: this.escapeHtml(row.blockedBy),
        date: row.blockedOn ? this.$options.filters.formatDateTime(row.blockedOn) : "",
      });
    },
    recordStatusOptions() {
      return this.$store.state.shippingData.recordStatuses || [];
    },
    recordTagOptions() {
      return this.$store.state.shippingData.recordTags || [];
    },
    recordTags() {
      return this.$store.state.shippingData.recordTags || [];
    },
    supplierNameOptions() {
      return this.$store.state.shippingData.supplierNames || [];
    },
    supplierByName() {
      const map = {};
      (this.$store.state.shippingData.supplierNames || []).forEach((s) => {
        map[s.name] = s;
      });
      return map;
    },
    supplierNamesOnly() {
      const sd = this.$store.state.shippingData;
      return (sd.supplierNames && sd.supplierNames.map((sn) => sn.name)) || [];
    },
    containerSizeOptions() {
      return this.$store.state.shippingData.containerSizes || [];
    },
    containerArrivalPlaceOptions() {
      return this.$store.state.shippingData.containerArrivalPlaces || [];
    },
    splitOptions() {
      return {
        recordStatusOptions: this.recordStatusOptions,
        containerSizeOptions: this.containerSizeOptions,
        containerArrivalPlaceOptions: this.containerArrivalPlaceOptions,
        carrierNameOptions: this.carrierNameOptions,
        supplierNameOptions: this.supplierNameOptions,
        paymentStatusOptions: this.paymentStatusOptions,
        shipmentPaidStatusOptions: this.shipmentPaidStatusOptions,
        customsPaidStatusOptions: this.customsPaidStatusOptions,
        chinaStatusOptions: this.chinaStatusOptions,
        chinaUserOptions: this.chinaUserOptions,
        accountingStatusOptions: this.accountingStatusOptions,
      };
    },
    carrierNameOptions() {
      return this.$store.state.shippingData.carrierNames || [];
    },
    paymentStatusOptions() {
      return this.$store.state.shippingData.paymentStatuses || [];
    },
    shipmentPaidStatusOptions() {
      return this.$store.state.shippingData.shipmentPaidStatuses || [];
    },
    customsPaidStatusOptions() {
      return this.$store.state.shippingData.customsPaidStatuses || [];
    },
    chinaStatusOptions() {
      return this.$store.state.shippingData.chinaStatuses || [];
    },
    linkedProductOptions() {
      return this.$store.state.shippingData.linkedProducts || [];
    },
    linkedProductNameOptions() {
      const sd = this.$store.state.shippingData;
      return (sd.linkedProducts && sd.linkedProducts.map((sn) => sn.sku)) || [];
    },
    documentTypeOptions() {
      return ["proforma_invoice", "commercial_invoice", "packing_list", "mtc", "co", "freight_invoice", "customs_invoice", "other"].map((v) => ({
        value: v,
        label: this.$t("shippingPlan.documentTypes." + v),
      }));
    },
    linkedProductSkuOptions() {
      return (this.$store.state.shippingData.linkedProducts || []).map((p) => ({
        value: p.id,
        sku: p.sku,
        purchasePrice: p.purchasePrice,
        condition: p.condition,
      }));
    },
    // Zur Auswahl angeboten wird nur Neuware. Bereits verknuepfte Artikel werden weiterhin ueber
    // linkedProductSkuOptions aufgeloest, damit keine bestehende Zeile leer laeuft.
    selectableProductSkuOptions() {
      return this.linkedProductSkuOptions.filter((p) => p.condition !== "B-Ware");
    },
    productTotalQuantity() {
      return this.productTags.reduce((s, t) => s + Number(t.count || 0), 0);
    },
    applicableCiRows() {
      return this.ciExtract.rows.filter((r) => r.skuObject && Number(r.count) > 0).length;
    },
    productTotalEk() {
      const hasEk = this.productTags.some((t) => t.ek != null && t.ek !== "");
      if (!hasEk) return "—";
      const sum = this.productTags.reduce((s, t) => s + (this.parseMoney(t.ek) || 0) * Number(t.count || 0), 0);
      return this.formatMoney(sum) + " $";
    },
    chinaUserOptions() {
      return this.$store.state.shippingData.chinaUsers || [];
    },
    accountingStatusOptions() {
      return this.$store.state.shippingData.accountingStatuses || [];
    },
    numberOfPlaces() {
      if (!this.tableData) return 0;

      return uniqBy(
        this.tableData.filter((t) => t.containerArrivalPlaceId),
        "containerArrivalPlaceId"
      ).length;
    },
    productsLocked() {
      return !!(this.form.wmsGebucht || this.form.afterbuyGebucht);
    },
    canConfirmWmsBooking() {
      const p = this.wmsBookingPreview;
      return !!(p && !p.alreadyBooked && p.hasExchangeRate && p.storageLocationId && p.rows && p.rows.length > 0);
    },
    wmsRateValid() {
      const v = Number(this.wmsRate.value);
      return this.wmsRate.value !== null && this.wmsRate.value !== "" && Number.isFinite(v) && v > 0;
    },
    canConfirmAfterbuyBooking() {
      const p = this.afterbuyBookingPreview;
      return !!(p && !p.alreadyBooked && p.allFound && p.rows && p.rows.length > 0);
    },
  },
  methods: {
    escapeHtml(val) {
      if (val === null || val === undefined) return "";
      return String(val).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    },
    formatMoney(val) {
      if (val === null || val === undefined || val === '') return '';
      const locale = this.$i18n.locale === 'de' ? 'de-DE' : 'en-GB';
      return Number(val).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true });
    },
    parseMoney(val) {
      if (val === null || val === undefined || val === '') return null;
      const str = this.$i18n.locale === 'de'
        ? String(val).replace(/\./g, '').replace(',', '.')
        : String(val).replace(/,/g, '');
      const n = parseFloat(str);
      return isNaN(n) ? null : n;
    },
    formatRate(val) {
      if (val === null || val === undefined || val === '') return '';
      const locale = this.$i18n.locale === 'de' ? 'de-DE' : 'en-GB';
      return Number(val).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 4, useGrouping: false });
    },
    formatMoneyField(field) {
      const n = this.parseMoney(this.form[field]);
      this.form[field] = n != null ? this.formatMoney(n) : null;
    },
    formatProductEk(tag) {
      const n = this.parseMoney(tag.ek);
      tag.ek = n != null ? this.formatMoney(n) : null;
    },
    // Aus dem Sticker-Dialog: Liste ist neu geladen - gesetzte Sticker neu einfaerben, Umbenennung mitziehen
    onRecordTagChanged({ oldName, newName }) {
      this.tags = this.tags.map((t) => this.colorizeTag(oldName && t.text === oldName ? newName : t.text));
    },
    colorizeTag(text) {
      const all = this.$store.state.shippingData.recordTags || [];
      const match = all.find((rt) => rt.name === text);
      if (!match || !match.color) return { text };
      const textColor = this.contrastingTextColor(match.color);
      return {
        text,
        style: `background-color: ${match.color}; border: 1px solid ${match.color}; color: ${textColor};`,
      };
    },
    contrastingTextColor(hex) {
      if (!hex) return "#fff";
      const c = hex.replace("#", "");
      if (c.length !== 6) return "#fff";
      const r = parseInt(c.substring(0, 2), 16);
      const g = parseInt(c.substring(2, 4), 16);
      const b = parseInt(c.substring(4, 6), 16);
      const luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luma > 0.6 ? "#000" : "#fff";
    },
    hideEditModal() {
      this.stopEditingPresence();
      this.release({ shipmentRecordId: this.form.shipmentRecordId });
      this.editModal = false;
    },
    startEditingPresence(shipmentRecordId) {
      if (this._signalrConnection && this._signalrConnection.state === signalR.HubConnectionState.Connected) {
        this._signalrConnection.invoke("StartEditing", shipmentRecordId).catch(() => {});
      }
    },
    stopEditingPresence() {
      if (this._signalrConnection && this._signalrConnection.state === signalR.HubConnectionState.Connected) {
        this._signalrConnection.invoke("StopEditing").catch(() => {});
      }
    },
    // Fremde Sperre brechen: Administratoren immer, sonst nur mit dem Unterpunkt "ForceRelease".
    canForceRelease() {
      return this.isAdmin() || this.hasPermission("Write", "ShippingPlans", "ForceRelease");
    },
    forceReleaseTitle(row) {
      const status = row.blockedActive ? this.$t("shippingPlan.messages.editorActive") : this.$t("shippingPlan.messages.editorInactive");
      return `${this.$t("shippingPlan.messages.blockedBy", { user: row.blockedBy })} — ${status}`;
    },
    confirmForceRelease(row) {
      this.forceReleaseTarget = row;
      this.forceReleaseDialog = true;
    },
    doForceRelease() {
      const row = this.forceReleaseTarget;
      if (!row) return;
      this.isLoading = true;
      this.$store
        .dispatch("shippingPlans/forceRelease", { shipmentRecordId: row.shipmentRecordId })
        .then((res) => {
          if (res && res.isSuccess) {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.released"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.forceReleaseError"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
          }
          this.$refs.table.refresh();
        })
        .catch(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.messages.forceReleaseError"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.forceReleaseTarget = null;
        });
    },
    hideCreateModal() {
      this.createModal = false;
    },
    createSupplierInline() {
      if (!this.newSupplierName) return;
      this.$store
        .dispatch("shippingData/createSupplier", { name: this.newSupplierName })
        .then(() => this.$store.dispatch("shippingData/getSupplierNames"))
        .then(() => {
          this.supplierName = this.newSupplierName;
          this.newSupplierName = null;
          this.createSupplierModal = false;
        });
    },
    hideHistoricalModal() {
      this.historicalModal = false;
    },
    showSplitModal(item) {
      this.isLoading = true;
      this.$store
        .dispatch("shippingPlans/block", { shipmentRecordId: item.shipmentRecordId })
        .then((res) => {
          if (!res.isSuccess) {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.blocked"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
            return;
          }
          item.canRelease = true;
          this.startEditingPresence(item.shipmentRecordId);
          this.splitSource = item;
          this.splitModal = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    hideSplitModal() {
      if (this.splitSource) {
        this.$store.dispatch("shippingPlans/release", { shipmentRecordId: this.splitSource.shipmentRecordId });
        this.stopEditingPresence();
      }
      this.splitModal = false;
      this.splitSource = null;
    },
    afterSplit(count) {
      this.$notify({
        timeout: 3500,
        message: this.$t("shippingPlan.split.done", { count }),
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
      this.hideSplitModal();
      this.$refs.table.refresh();
    },
    showEditModal(item) {
      this.isLoading = true;
      this.$store
        .dispatch("shippingPlans/block", {
          shipmentRecordId: item.shipmentRecordId,
        })
        .then((res) => {
          if (!res.isSuccess) {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.blocked"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
            return;
          }

          item.canRelease = true;
          this.startEditingPresence(item.shipmentRecordId);

          Object.assign(this.form, item);
          this.containerArrivalDateType = item.containerArrivalDateFixed ? 'fixed' : item.containerArrivalDatePlanned ? 'planned' : item.containerArrivalDateProvisional ? 'provisional' : null;
          this.form.containerArrivalDateInput = item.containerArrivalDate ? new Date(item.containerArrivalDate) : this.newDate();
          this.form.containerBookingStatus = item.containerBookingStatus || "pending";
          this.form.mtcStatus = item.mtcStatus || "pending";
          this.form.coStatus = item.coStatus || "pending";
          this.form.containerBookingDateInput = item.containerBookingDate ? new Date(item.containerBookingDate) : null;
          this.form.productDataSent = item.productDataSent || false;
          this.form.prepaymentDateInput = item.prepaymentDate ? new Date(item.prepaymentDate) : null;
          this.form.fullPaidDateInput = item.fullpaidDate ? new Date(item.fullpaidDate) : null;
          this.form.accountingStatusDateInput = item.accountingStatusDate ? new Date(item.accountingStatusDate) : null;
          this.form.shipmentAmount = item.shipmentAmount != null ? this.formatMoney(item.shipmentAmount) : null;
          this.form.customsAmount = item.customsAmount != null ? this.formatMoney(item.customsAmount) : null;
          this.form.orderTotalAmount = item.orderTotalAmount != null ? this.formatMoney(item.orderTotalAmount) : null;
          this.form.prepaymentAmount = item.prepaymentAmount != null ? this.formatMoney(item.prepaymentAmount) : null;
          this.uploadFiles = [];
          this.tags = (item.recordTags && item.recordTags.split(",").map((t) => this.colorizeTag(t))) || [];
          this.productTags =
            (item.products &&
              item.products.map((t) => ({
                linkedProductId: t.linkedProductId || 0,
                uid: t.linkedProductId ? `db-${t.linkedProductId}` : `tmp-${++this.productTagSeq}`,
                text: t.sku,
                id: t.id,
                count: t.quantityDelivering,
                ek: t.purchasePrice != null ? this.formatMoney(t.purchasePrice) : null,
                skuObject: this.linkedProductSkuOptions.find((p) => p.value === t.id) || null,
              }))) ||
            [];
          let sn = this.supplierNameOptions.filter((s) => s.id === item.supplierNameId);
          this.supplierName = sn && sn[0] && sn[0].name;
          this.form.linkedProductIds = (item.products && item.products.map((p) => p.id)) || [];
          this.documents = item.documents || [];
          this.docUpload = { file: null, type: null, dragOver: false, saving: false };
          this.editModal = true;
        })
        .finally((_) => {
          this.isLoading = false;
        });
    },
    release(item) {
      this.isLoading = true;
      this.$store
        .dispatch("shippingPlans/release", {
          shipmentRecordId: item.shipmentRecordId,
        })
        .then((res) => {
          if (!res.isSuccess) {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.canNotRelease"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
            return;
          }

          item.canRelease = false;
          let releaseItem = this.tableData.find((i) => i.shipmentRecordId === item.shipmentRecordId);
          if (releaseItem) {
            releaseItem.canRelease = false;
            releaseItem.blockedBy = null;
            releaseItem.blockedById = null;
            releaseItem.blockedOn = null;
            releaseItem.blockedActive = false;
          }

          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.messages.released"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .finally((_) => {
          this.isLoading = false;
        });
    },
    createShipppingPlan() {
      const sn = this.supplierNameOptions.filter((s) => s.name === this.supplierName);
      const supplierNameId = sn && sn[0] && sn[0].id;
      this.$refs.createForm.validate().then((success) => {
        if (!success) {
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.messages.requiredFields"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }

        this.isLoading = true;
        this.$store
          .dispatch("shippingPlans/createShippingPlan", {
            shipmentRecordName: this.shipmentRecordName,
            supplierOrderId: this.supplierOrderId,
            supplierNameId: supplierNameId,
            containerArrivalDate: formatISO(this.containerArrivalDateInput),
            containerArrivalDateFixed: this.containerArrivalDateFixed ?? false,
            containerArrivalDatePlanned: this.containerArrivalDatePlanned ?? false,
            containerArrivalDateProvisional: this.containerArrivalDateProvisional ?? false,
            containerBookingStatus: "pending",
            mtcStatus: "pending",
            coStatus: "pending",
          })
          .then(() => {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.created"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            this.applyFilters();
          })
          .then(() => {
            this.hideCreateModal();
          })
          .catch(() => {
            // Fehlgeschlagen: Dialog bleibt offen, die Meldung kommt aus dem Interceptor.
          })
          .finally((_) => {
            this.isLoading = false;
          });
      });
    },
    notifyOnlyPdf() {
      this.$notify({
        timeout: 2500,
        message: this.$t("shippingPlan.onlyPdf"),
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
      });
    },
    isPdfFile(file) {
      if (!file) return false;
      return file.type === 'application/pdf' || (file.name && file.name.toLowerCase().endsWith('.pdf'));
    },
    documentByType(type) {
      return this.documents.find((d) => d.type === type) || null;
    },
    onDocumentPicked(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!this.isPdfFile(file)) {
        this.notifyOnlyPdf();
        event.target.value = "";
        return;
      }
      this.docUpload.file = file;
    },
    onDocumentDrop(event) {
      this.docUpload.dragOver = false;
      const file = event.dataTransfer.files[0];
      if (!file) return;
      if (!this.isPdfFile(file)) {
        this.notifyOnlyPdf();
        return;
      }
      this.docUpload.file = file;
    },
    onDocumentDragLeave(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.docUpload.dragOver = false;
      }
    },
    loadDocuments() {
      return axiosFactory()
        .get(`/shipping_plans/${this.form.shipmentRecordId}/documents`)
        .then((res) => {
          this.documents = (res.data && res.data.data) || [];
        });
    },
    saveDocument() {
      const type = this.docUpload.type && this.docUpload.type.value;
      if (!this.docUpload.file || !type) return;

      // Ausser bei "Sonstiges" ersetzt ein Upload das vorhandene Dokument des Typs.
      const vorhanden = type !== "other" && this.documentByType(type);
      if (vorhanden && !window.confirm(this.$t("shippingPlan.confirmReplaceDocument", { name: vorhanden.name }))) return;

      const formData = new FormData();
      formData.append("file", this.docUpload.file);
      formData.append("type", type);
      this.docUpload.saving = true;
      axiosFactory()
        .post(`/shipping_plans/${this.form.shipmentRecordId}/documents`, formData, { headers: { "Content-Type": "multipart/form-data" } })
        .then((res) => {
          this.docUpload.file = null;
          this.docUpload.type = null;
          if (this.$refs.docFile) this.$refs.docFile.value = "";
          this.notifyDocument("success", "shippingPlan.messages.documentUploaded");
          const freight = res.data && res.data.data && res.data.data.freight;
          if (freight) this.openFreightConfirm(freight);
          const customs = res.data && res.data.data && res.data.data.customs;
          if (customs) this.openCustomsConfirm(customs);
          return this.loadDocuments();
        })
        .catch((err) => {
          const reason = (err.response && err.response.data && err.response.data.reason) || "upload_failed";
          this.notifyDocument("danger", `shippingPlan.documentErrors.${reason}`);
        })
        .finally(() => {
          this.docUpload.saving = false;
        });
    },
    previewDocument(d) {
      this.pdfModal.title = d.name;
      this.pdfModal.url = "";
      this.pdfModal.show = true;
      axiosFactory()
        .get(`/shipping_plans/${this.form.shipmentRecordId}/documents/${d.id}/content`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: d.contentType || "application/pdf" });
          this.pdfModal.url = URL.createObjectURL(blob);
        })
        .catch(() => {
          this.closePdfModal();
          this.notifyDocument("danger", "shippingPlan.documentErrors.file_missing");
        });
    },
    // Schieberegler "Dokument geprueft": speichert sofort, ein neues oder ersetztes Dokument startet serverseitig ungeprueft
    async setDocumentChecked(d, value) {
      const isChecked = !!value;
      this.docChecking = d.id;
      try {
        const res = await axiosFactory().put(`/shipping_plans/${this.form.shipmentRecordId}/documents/${d.id}/checked`, { isChecked });
        const saved = (res.data && res.data.data) || {};
        d.isChecked = saved.isChecked != null ? saved.isChecked : isChecked;
        d.checkedOn = saved.checkedOn || null;
        d.checkedBy = saved.checkedBy || null;
      } catch (e) {
        const reason = e && e.response && e.response.data && e.response.data.reason;
        // d bleibt unveraendert, der Schalter springt damit auf den gespeicherten Stand zurueck
        this.notifyDocument("danger", reason === "blocked" ? "shippingPlan.documentErrors.blocked" : "shippingPlan.documentErrors.check_failed");
      } finally {
        this.docChecking = null;
      }
    },
    documentChecked(row, type) {
      return !!(row.documents && row.documents.some((d) => d.type === type && d.isChecked));
    },
    confirmDeleteDocument(d) {
      if (!window.confirm(this.$t("shippingPlan.confirmDeleteDocument", { name: d.name }))) return;
      axiosFactory()
        .delete(`/shipping_plans/${this.form.shipmentRecordId}/documents/${d.id}`)
        .then(() => {
          this.notifyDocument("success", "shippingPlan.messages.documentDeleted");
          return this.loadDocuments();
        })
        .catch(() => {
          this.notifyDocument("danger", "shippingPlan.documentErrors.delete_failed");
        });
    },
    // Erkennung ist ein Vorschlag: Werte werden dem Nutzer vorgelegt, nicht still uebernommen.
    openFreightConfirm(freight) {
      this.freightConfirm = {
        show: true,
        error: freight.error || null,
        documentNumber: freight.documentNumber || null,
        amount: freight.amount != null ? this.formatMoney(freight.amount) : null,
        paidStatusId: freight.paidStatusId || null,
      };
    },
    rateNotify(type, message) {
      this.$notify({ timeout: 4000, message, icon: "add_alert", horizontalAlign: "right", verticalAlign: "top", type });
    },
    // Kurs aus dem hinterlegten Dokument lesen - dieselbe Extraktion wie die CI-Positionen,
    // uebernommen wird aber nur der Kursblock (EZB-Tageskurs zum Rechnungsdatum)
    async extractRateFromDocument() {
      const doc = this.documentByType("commercial_invoice") ? "ci" : "pi";
      this.rateExtract.loading = true;
      try {
        const res = await axiosFactory().get(`/shipping_plans/${this.form.shipmentRecordId}/invoice_positions?document=${doc}`);
        const data = res.data.data || {};
        if (data.exchangeRate != null) {
          this.form.exchangeRate = Math.round(data.exchangeRate * 10000) / 10000;
          const applied = this.$t("shippingPlan.exchangeRateLookup.applied", {
            rate: this.formatRate(this.form.exchangeRate),
            date: this.$options.filters.formatDate(data.exchangeRateDate || data.invoiceDate),
          });
          this.rateNotify("success", applied);
        } else {
          this.rateNotify("warning", this.$t("shippingPlan.exchangeRateLookup.noRate"));
        }
      } catch (e) {
        const reason = e && e.response && e.response.data && e.response.data.reason;
        const known = ["not_found", "no_ci", "file_missing", "extract_failed", "no_text_layer", "webhook_error"];
        this.rateNotify("danger", this.$t(known.includes(reason) ? "shippingPlan.ciExtract.errors." + reason : "shippingPlan.exchangeRateLookup.error"));
      } finally {
        this.rateExtract.loading = false;
      }
    },
    openRateLookup(target = "form") {
      this.rateLookup = { show: true, date: new Date().toISOString().slice(0, 10), loading: false, rate: null, rateDate: null, error: null, target };
      this.lookupRate();
    },
    async lookupRate() {
      if (!this.rateLookup.date) return;
      this.rateLookup.loading = true;
      this.rateLookup.error = null;
      this.rateLookup.rate = null;
      try {
        const res = await axiosFactory().get(`/shipping_plans/exchange_rate`, { params: { date: this.rateLookup.date } });
        const data = res.data.data || {};
        this.rateLookup.rate = data.rate;
        this.rateLookup.rateDate = data.rateDate;
      } catch (e) {
        this.rateLookup.error = true;
      } finally {
        this.rateLookup.loading = false;
      }
    },
    applyLookupRate() {
      if (this.rateLookup.rate != null) {
        const rate = Math.round(this.rateLookup.rate * 10000) / 10000;
        if (this.rateLookup.target === "wms") this.wmsRate.value = rate;
        else this.form.exchangeRate = rate;
      }
      this.rateLookup.show = false;
    },
    // Wechselkurs direkt in der Lightbox "Ins WMS/OCC einbuchen" (Karte "Wechselkurs eintragen und speichern"):
    // gleiche Quellen wie im Reiter Auftrag, gespeichert wird nur der Kurs, danach laedt die Vorschau neu.
    async wmsExtractRate() {
      this.wmsRate.extracting = true;
      try {
        const res = await axiosFactory().get(`/shipping_plans/${this.wmsBookingRecordId}/invoice_positions?document=${this.wmsBookingPreview.rateDocument}`);
        const data = res.data.data || {};
        if (data.exchangeRate != null) {
          this.wmsRate.value = Math.round(data.exchangeRate * 10000) / 10000;
          const applied = this.$t("shippingPlan.exchangeRateLookup.applied", {
            rate: this.formatRate(this.wmsRate.value),
            date: this.$options.filters.formatDate(data.exchangeRateDate || data.invoiceDate),
          });
          this.rateNotify("success", applied);
        } else {
          this.rateNotify("warning", this.$t("shippingPlan.exchangeRateLookup.noRate"));
        }
      } catch (e) {
        const reason = e && e.response && e.response.data && e.response.data.reason;
        const known = ["not_found", "no_ci", "file_missing", "extract_failed", "no_text_layer", "webhook_error"];
        this.rateNotify("danger", this.$t(known.includes(reason) ? "shippingPlan.ciExtract.errors." + reason : "shippingPlan.exchangeRateLookup.error"));
      } finally {
        this.wmsRate.extracting = false;
      }
    },
    async saveWmsRate() {
      if (!this.wmsRateValid || this.wmsRate.saving) return;
      this.wmsRate.saving = true;
      const id = this.wmsBookingRecordId;
      try {
        await axiosFactory().put(`/shipping_plans/${id}/exchange_rate`, { exchangeRate: Number(this.wmsRate.value) });
        this.rateNotify("success", this.$t("shippingPlan.wms.rateSaved"));
        await this.loadWmsBookingPreview(id);
      } catch (e) {
        const reason = e && e.response && e.response.data && e.response.data.reason;
        const keys = { blocked: "shippingPlan.wms.rateBlocked", already_booked: "shippingPlan.wms.alreadyBooked", invalid_rate: "shippingPlan.wms.rateInvalid" };
        this.rateNotify("danger", this.$t(keys[reason] || "shippingPlan.wms.rateError"));
      } finally {
        this.wmsRate.saving = false;
      }
    },
    applyFreightConfirm() {
      const f = this.freightConfirm;
      if (f.documentNumber) this.form.shipmentDocumentNumber = f.documentNumber;
      if (f.amount) this.form.shipmentAmount = f.amount;
      if (f.paidStatusId) this.form.shipmentPaidStatusId = f.paidStatusId;
      this.freightConfirm.show = false;
      this.notifyDocument("success", "shippingPlan.freightExtract.applied");
      // Anschlussschritt: Frachtsumme volumenanteilig als BZNK auf die WMS-Einträge des Containers verteilen.
      const amount = this.parseMoney(f.amount);
      if (amount) this.openFreightAllocation(amount);
    },
    openCustomsConfirm(customs) {
      this.customsConfirm = {
        show: true,
        error: customs.error || null,
        documentNumber: customs.documentNumber || null,
        amount: customs.amount != null ? this.formatMoney(customs.amount) : null,
        paidStatusId: customs.paidStatusId || null,
      };
    },
    applyCustomsConfirm() {
      const c = this.customsConfirm;
      if (c.documentNumber) this.form.customsDocumentNumber = c.documentNumber;
      if (c.amount) this.form.customsAmount = c.amount;
      if (c.paidStatusId) this.form.customsPaidStatusId = c.paidStatusId;
      this.customsConfirm.show = false;
      this.notifyDocument("success", "shippingPlan.customsExtract.applied");
    },
    openFreightAllocation(amount) {
      this.freightAllocation = { show: true, loading: true, saving: false, error: null, containerId: null, amount, amountInput: this.formatMoney(amount), totalVolume: null, skusWithoutVolume: [], rows: [] };
      this.loadFreightAllocation();
    },
    // Eine Frachtrechnung kann mehrere Sendungen decken: die Summe ist deshalb aenderbar,
    // die Vorschlaege rechnen mit dem neuen Betrag einfach neu (der GET ist zustandslos)
    reloadFreightAllocation() {
      const amount = this.parseMoney(this.freightAllocation.amountInput);
      if (!amount || amount <= 0) {
        this.freightAllocation.amountInput = this.formatMoney(this.freightAllocation.amount);
        return;
      }
      this.freightAllocation.amount = amount;
      this.freightAllocation.amountInput = this.formatMoney(amount);
      this.freightAllocation.loading = true;
      this.loadFreightAllocation();
    },
    loadFreightAllocation() {
      const amount = this.freightAllocation.amount;
      axiosFactory()
        .get(`/shipping_plans/${this.form.shipmentRecordId}/freight_allocation`, { params: { amount } })
        .then((res) => {
          const data = (res.data && res.data.data) || {};
          if (data.error) {
            // Fehlende Wareneingaenge sind der haeufigste Fall und kein Fehler des Nutzers:
            // Hinweis im Dialog stehen lassen, statt ihn mit einem Toast zu schliessen.
            if (data.error === "no_wms_entries") {
              this.freightAllocation.error = data.error;
              this.freightAllocation.containerId = data.containerId;
              this.freightAllocation.rows = [];
              return;
            }
            this.freightAllocation.show = false;
            this.notifyDocument("danger", `shippingPlan.freightAllocation.errors.${data.error}`);
            return;
          }
          this.freightAllocation.error = null;
          this.freightAllocation.containerId = data.containerId;
          this.freightAllocation.totalVolume = data.totalVolume;
          this.freightAllocation.skusWithoutVolume = data.skusWithoutVolume || [];
          this.freightAllocation.rows = (data.rows || []).map((r) => ({
            ...r,
            bznk: r.proposedBznk != null ? this.formatMoney(r.proposedBznk) : this.formatMoney(r.currentBznk),
          }));
        })
        .catch(() => {
          this.freightAllocation.show = false;
          this.notifyDocument("danger", "shippingPlan.freightAllocation.errors.load_failed");
        })
        .finally(() => {
          this.freightAllocation.loading = false;
        });
    },
    formatAllocationRow(r) {
      const n = this.parseMoney(r.bznk);
      r.bznk = n != null ? this.formatMoney(n) : null;
    },
    formatVolume(val) {
      if (val === null || val === undefined || val === "") return "–";
      const locale = this.$i18n.locale === "de" ? "de-DE" : "en-GB";
      return Number(val).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 6, useGrouping: true });
    },
    applyFreightAllocation() {
      const rows = this.freightAllocation.rows
        .map((r) => ({ inventoryId: r.inventoryId, bznk: this.parseMoney(r.bznk) }))
        .filter((r) => r.bznk != null);
      if (!rows.length) {
        this.freightAllocation.show = false;
        return;
      }
      this.freightAllocation.saving = true;
      axiosFactory()
        .post(`/shipping_plans/${this.form.shipmentRecordId}/freight_allocation`, rows)
        .then(() => {
          this.freightAllocation.show = false;
          this.notifyDocument("success", "shippingPlan.freightAllocation.applied");
        })
        .catch((err) => {
          const reason = (err.response && err.response.data && err.response.data.reason) || "apply_failed";
          this.notifyDocument("danger", `shippingPlan.freightAllocation.errors.${reason}`);
        })
        .finally(() => {
          this.freightAllocation.saving = false;
        });
    },
    notifyDocument(type, messageKey) {
      this.$notify({
        timeout: 2500,
        message: this.$t(messageKey),
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type,
      });
    },
    downloadDocument({ id, name }) {
      if (id === 0 || !name) return;
      this.pdfModal.title = name;
      this.pdfModal.url = '';
      this.pdfModal.show = true;
      // name als params-Objekt statt String-Interpolation: Dateinamen mit "&" (z.B. "PL&INV ...")
      // zerschneiden sonst den Query-String und die Datei wird nie gefunden
      axiosFactory().get(`/files/${id}`, { params: { name }, responseType: 'blob' }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfModal.url = URL.createObjectURL(blob);
      });
    },
    closePdfModal() {
      if (this.pdfModal.url) URL.revokeObjectURL(this.pdfModal.url);
      this.pdfModal = { show: false, url: '', title: '' };
    },
    addInlineProductRow() {
      this.productTags.push({ linkedProductId: 0, uid: `tmp-${++this.productTagSeq}`, skuObject: null, text: null, id: null, count: null, ek: null });
    },
    openCiExtract() {
      this.ciExtract = { modal: true, loading: false, choose: false, rows: [], error: null, counts: null, pdfUrl: null, invoiceDate: null, exchangeRate: null, exchangeRateDate: null, applyRate: false };
      const hasCi = !!this.documentByType("commercial_invoice");
      const hasPi = !!this.documentByType("proforma_invoice");
      if (hasCi && hasPi) {
        this.ciExtract.choose = true;
        return;
      }
      this.loadCiExtract(hasCi ? "ci" : "pi");
    },
    loadCiExtract(doc) {
      this.ciExtract.choose = false;
      this.ciExtract.loading = true;
      const document = this.documentByType(doc === "pi" ? "proforma_invoice" : "commercial_invoice");
      axiosFactory()
        .get(`/shipping_plans/${this.form.shipmentRecordId}/documents/${document.id}/content`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.ciExtract.pdfUrl = URL.createObjectURL(blob);
        })
        .catch(() => {});
      axiosFactory()
        .get(`/shipping_plans/${this.form.shipmentRecordId}/invoice_positions?document=${doc}`)
        .then((res) => {
          const data = res.data.data || {};
          this.ciExtract.counts = data.counts || null;
          this.ciExtract.invoiceDate = data.invoiceDate || null;
          this.ciExtract.exchangeRate = data.exchangeRate != null ? Math.round(data.exchangeRate * 10000) / 10000 : null;
          this.ciExtract.exchangeRateDate = data.exchangeRateDate || null;
          this.ciExtract.applyRate = this.ciExtract.exchangeRate != null && !this.form.exchangeRate;
          this.ciExtract.rows = (data.rows || []).map((r) => ({
            uid: `ci-${++this.productTagSeq}`,
            status: r.status,
            checksumOk: r.checksumOk,
            skuRaw: r.skuRaw,
            description: r.description,
            skuObject: r.sku ? this.linkedProductSkuOptions.find((p) => p.sku === r.sku) || null : null,
            count: r.quantity != null ? String(r.quantity) : null,
            ek: r.unitPrice != null ? this.formatMoney(r.unitPrice) : null,
          }));
        })
        .catch((e) => {
          const reason = e && e.response && e.response.data && e.response.data.reason;
          this.ciExtract.error = ["not_found", "no_ci", "file_missing", "extract_failed", "no_text_layer", "webhook_error"].includes(reason) ? reason : "webhook_error";
        })
        .finally(() => {
          this.ciExtract.loading = false;
        });
    },
    rowAmpel(r) {
      if (!r.skuObject) return "red";
      return r.checksumOk === false ? "orange" : "green";
    },
    removeCiRow(row) {
      this.ciExtract.rows = this.ciExtract.rows.filter((r) => r !== row);
    },
    closeCiExtract() {
      if (this.ciExtract.pdfUrl) URL.revokeObjectURL(this.ciExtract.pdfUrl);
      this.ciExtract.modal = false;
      this.ciExtract.pdfUrl = null;
    },
    applyCiRows() {
      const usable = this.ciExtract.rows.filter((r) => r.skuObject && Number(r.count) > 0);
      usable.forEach((r) => {
        this.productTags.push({
          linkedProductId: 0,
          uid: `tmp-${++this.productTagSeq}`,
          skuObject: r.skuObject,
          text: r.skuObject.sku,
          id: r.skuObject.value,
          count: Number(r.count),
          ek: r.ek,
        });
      });
      if (this.ciExtract.applyRate && this.ciExtract.exchangeRate != null) {
        this.form.exchangeRate = this.ciExtract.exchangeRate;
      }
      this.closeCiExtract();
      this.$notify({
        timeout: 2500,
        message: this.$t("shippingPlan.ciExtract.applied", { count: usable.length }),
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
    },
    removeProductTag(index) {
      this.productTags.splice(index, 1);
    },
    fuseSearchSKU(_options, search) {
      const fuse = new Fuse(_options, {
        keys: ["sku"],
        shouldSort: true,
        minMatchCharLength: 1,
        includeMatches: true,
        threshold: 0.3,
      });
      if (!search.length) return _options;
      return fuse.search(search).map(({ item }) => ({
        ...item,
        exact: item.sku.toLowerCase() === search.toLowerCase(),
      }));
    },
    onNewProductSaved(sku) {
      this.$store.dispatch("shippingData/getLinkedProducts").then(() => {
        const created = this.linkedProductSkuOptions.find((p) => p.sku === sku);
        if (created) {
          this.productTags.push({ linkedProductId: 0, uid: `tmp-${++this.productTagSeq}`, skuObject: created, text: created.sku, id: created.value, count: null, ek: created.purchasePrice || null });
        }
        this.createNewProductModal = false;
      });
    },
    removeProduct(product) {
      if (this.productTags) {
        this.productTags = this.productTags.filter((p) => p.uid !== product.uid);
      }
    },
    editShipppingPlan() {
      const sn = this.supplierNameOptions.filter((s) => s.name === this.supplierName);
      if (!this.supplierName || !sn.length) {
        this.$notify({
          timeout: 2500,
          message: this.$t("shippingPlan.messages.invalidSupplierName"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      this.form.supplierNameId = sn[0].id;
      this.$refs.form.validate().then((success) => {
        if (!success) {
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.messages.requiredFields"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }

        const orderPlaced = this.recordStatusOptions.find((o) => o.name === "Order placed");
        if (orderPlaced && this.form.recordStatusId === orderPlaced.id && this.form.containerId && String(this.form.containerId).trim()) {
          this.$notify({
            timeout: 3500,
            message: this.$t("shippingPlan.messages.containerStatusMismatch"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }

        const formData = new FormData();
        this.form.containerArrivalDateFixed = this.containerArrivalDateType === 'fixed';
        this.form.containerArrivalDatePlanned = this.containerArrivalDateType === 'planned';
        this.form.containerArrivalDateProvisional = this.containerArrivalDateType === 'provisional';
        const inputs = Object.assign({}, this.form);
        inputs.containerBookingDate = this.form.containerBookingDateInput ? format(this.form.containerBookingDateInput, "yyyy-MM-dd") : null;
        inputs.containerArrivalDate = this.form.containerArrivalDateInput ? formatISO(this.form.containerArrivalDateInput) : null;
        inputs.prepaymentDate = this.form.prepaymentDateInput ? format(this.form.prepaymentDateInput, "yyyy-MM-dd") : null;
        inputs.fullpaidDate = this.form.fullPaidDateInput ? format(this.form.fullPaidDateInput, "yyyy-MM-dd") : null;
        inputs.accountingStatusDate = this.form.accountingStatusDateInput ? format(this.form.accountingStatusDateInput, "yyyy-MM-dd") : null;
        inputs.orderTotalAmount = this.parseMoney(inputs.orderTotalAmount);
        inputs.prepaymentAmount = this.parseMoney(inputs.prepaymentAmount);
        inputs.shipmentAmount = this.parseMoney(inputs.shipmentAmount);
        inputs.customsAmount = this.parseMoney(inputs.customsAmount);
        forEach(inputs, (val, key) => {
          // Objekte/Arrays (documents, products) gehoeren nicht als Formularwert ins PUT.
          if (val && typeof val !== "object" && key !== "linkedProductIds" && key !== "recordTags") {
            formData.append(`${key}`, val);
          }
        });
        formData.append("productDataSent", inputs.productDataSent ? "true" : "false");

        if (this.tags && this.tags.length > 0) {
          formData.append(`recordTags`, this.tags.map((t) => t.text).join(","));
        }

        if (this.productTags && this.productTags.length > 0) {
          formData.append(
            `linkedProducts`,
            JSON.stringify(
              this.productTags
                .filter((t) => t.skuObject || t.id)
                .map((t, index) => ({
                  linkedProductId: t.linkedProductId || 0,
                  id: t.skuObject ? t.skuObject.value : (t.id || 0),
                  name: t.skuObject ? t.skuObject.sku : t.text,
                  quantityDelivering: t.count,
                  purchasePrice: this.parseMoney(t.ek),
                  position: index,
                }))
            )
          );
        } else {
          formData.append(`linkedProducts`, "");
        }

        this.isLoading = true;
        axiosFactory()
          .put(`/shipping_plans`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$notify({
              timeout: 2500,
              message: this.$t("shippingPlan.messages.updated"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            this.applyFilters({});
            this.$store.dispatch("shippingData/getRecordTags");
          })
          .then(() => {
            this.hideEditModal();
          })
          .catch((err) => {
            // Fehlendes Recht meldet schon der Interceptor - hier nicht doppelt melden.
            if (err?.status === "forbidden") return;
            console.error("Save error:", err.response?.status, err.response?.data);
            this.$notify({
              timeout: 4000,
              message: `Fehler beim Speichern: ${err.response?.status ?? ""} ${JSON.stringify(err.response?.data ?? err)}`,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    debounceApplyFilters: debounce(function () {
      this.applyFilters({});
    }, 300),
    onIncludeArchivedChange() {
      this.$refs.table.options.params = {
        ...this.$refs.table.options.params,
        excludeArchived: !this.includeArchived,
      };
      this.$refs.table.refresh();
    },
    // Klick auf den Lieferantennamen in der Uebersicht: auf diesen Lieferanten filtern
    // (Trello 20.08., gleiche Mechanik wie im Bestellwesen)
    filterBySupplier(row) {
      this.$refs.drawerFilter.setSupplier(row.supplierNameId);
    },
    applyFilters(filters) {
      stickyTableHeader({ selector: "#shipping-plan-table" });
      this.$refs.table.options.params = {
        ...this.$refs.table.options.params,
        ...this.filter,
        ...filters,
      };
      this.currentPage = 1;
      this.$refs.table.setPage(this.currentPage);
    },
    newDate() {
      const d = new Date();
      d.setDate(d.getDate() + 60);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 8, 0, 0);
    },
    requestFunction(data) {
      const { page, limit, orderBy, ascending, pageIndex: staleIndex, ...filters } = data;
      this.currentPage = page;
      let params = {
        // vue-tables liefert page 1-basiert, die API erwartet pageIndex 0-basiert
        pageIndex: Math.max(0, page - 1),
        pageSize: limit,
        orderBy,
        ascending,
        ...filters,
      };

      this.isLoading = true;
      return axiosFactory()
        .get(`/shipping_plans`, { params })
        .catch(function (e) {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    responseFunction({ data }) {
      this.tableData = data.data;
      this.totalItems = data.total;
      if (data.totals) {
        this.footerOrderTotalAmount = data.totals.orderTotalAmount;
        this.footerPrepaymentAmount = data.totals.prepaymentAmount;
        this.footerOpenAmount = data.totals.openAmount;
      }
      if (!this.didInitialScroll) {
        this.didInitialScroll = true;
        this.$nextTick(() => this.scrollToToday());
      }

      return {
        data: this.tableData,
        count: data.total,
      };
    },
    rowClassCallback(row) {
      if (row.recordStatus === "Delivery date in planning") {
        return "delivery-date-in-planing";
      }

      if (row.recordStatus === "Delivery Date fixed") {
        return "delivery-date-fixed";
      }

      if (row.recordStatus === "Delivered") {
        return "delivered";
      }

      if (row.recordStatus === "Archived") {
        return "archived";
      }
      return "";
    },
    copyContainerId(val) {
      navigator.clipboard.writeText(val);
    },
    copyCreditor(val) {
      if (val == null) return;
      navigator.clipboard.writeText(String(val));
    },
    openCreateModal() {
      this.shipmentRecordName = null;
      this.supplierOrderId = null;
      this.supplierName = null;
      this.containerArrivalDateInput = this.newDate();
      this.containerArrivalDateFixed = false;
      this.containerArrivalDatePlanned = false;
      this.containerArrivalDateProvisional = true;
      this.createModal = true;
    },
    toggleDockSearch() {
      this.dockSearchOpen = !this.dockSearchOpen;
      if (this.dockSearchOpen) {
        this.$nextTick(() => this.$refs.dockSearchInput && this.$refs.dockSearchInput.$el.focus());
      }
    },
    confirmDelete(row) {
      this.deleteRow = row;
      this.deleteModal = true;
    },
    hideDelete() {
      this.deleteModal = false;
      this.deleteRow = null;
    },
    doDelete() {
      const row = this.deleteRow;
      if (!row) return;

      this.isDeleting = true;
      return axiosFactory()
        .delete(`/shipping_plans/${row.shipmentRecordId}`)
        .then(() => {
          this.hideDelete();
          this.$refs.table.refresh();
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.delete.done"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((err) => {
          // Der Knopf ist bei gebuchten Vorgaengen ausgeblendet; gebucht werden kann aber
          // zwischenzeitlich von jemand anderem. Ebenso kann inzwischen jemand die Sperre halten.
          const reason = (err && err.reason) || (err && err.response && err.response.data && err.response.data.reason);
          const key = reason === "already_booked" || reason === "blocked" || reason === "not_found" ? `shippingPlan.delete.${reason}` : "shippingPlan.delete.failed";
          this.$notify({
            timeout: 4000,
            message: this.$t(key),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        })
        .finally(() => {
          this.isDeleting = false;
        });
    },
    sendDocumentCIRow(row) {
      this.isLoading = true;
      return axiosFactory()
        .put(`/shipping_plans/send_document_ci`, { shipmentRecordIds: [row.shipmentRecordId] })
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.messages.documentSent"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.$refs.table.refresh();
          return;
        })
        .catch((e) => {
          const error = e && e.response && e.response.data && e.response.data.error;
          this.$notify({
            timeout: 4000,
            message: error === "no_documents" ? this.$t("shippingPlan.messages.documentSendNoDocuments") : this.$t("shippingPlan.messages.documentSendFailed"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    scrollToToday() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let idx = this.tableData.findIndex((r) => r.containerArrivalDate && new Date(r.containerArrivalDate) >= today);
      if (idx < 0) {
        idx = this.tableData.length - 1;
      }
      if (idx <= 0) return;
      const rows = document.querySelectorAll("#shipping-plan-table table tbody tr");
      const row = rows[idx];
      if (row) {
        row.scrollIntoView({ block: "start" });
      }
    },
    shortPlaceName(name) {
      if (!name) return name;
      const n = name.trim();
      if (n.includes("Wittlich")) return "Wittlich";
      if (n.includes("Piesport")) return "Piesport";
      if (n.includes("Bayer")) return "Bayer u. Sohn";
      if (/v\s*&\s*v|v\s+und\s+v/i.test(n)) return "V&V Logistik";
      return n.replace("Warenlager", "Lager");
    },
    openWmsBooking(row) {
      this.wmsBookingRecordId = row.shipmentRecordId;
      this.wmsBookingPreview = null;
      this.wmsRate = { value: null, extracting: false, saving: false };
      this.wmsBookingModal = true;
      this.loadWmsBookingPreview(row.shipmentRecordId);
    },
    loadWmsBookingPreview(id) {
      this.wmsBookingLoading = true;
      return axiosFactory()
        .get(`/shipping_plans/${id}/wms_booking_preview`)
        .then((res) => {
          this.wmsBookingPreview = res.data.data;
        })
        .catch(() => {
          this.$notify({
            timeout: 3000,
            message: this.$t("shippingPlan.wms.previewError"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.hideWmsBooking();
        })
        .finally(() => {
          this.wmsBookingLoading = false;
        });
    },
    hideWmsBooking() {
      this.wmsBookingModal = false;
      this.wmsBookingPreview = null;
      this.wmsBookingRecordId = null;
    },
    confirmWmsBooking() {
      // Doppelklick-Schutz wie bei der Afterbuy-Buchung (21.08.)
      if (!this.canConfirmWmsBooking || this.wmsBookingSubmitting) {
        return;
      }
      this.wmsBookingSubmitting = true;
      const id = this.wmsBookingRecordId;
      this.isLoading = true;
      axiosFactory()
        .post(`/shipping_plans/${id}/book_to_wms`)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.wms.bookSuccess"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.hideWmsBooking();
          this.applyFilters({});
        })
        .catch((err) => {
          const reason = err.response && err.response.data && err.response.data.reason;
          const reasonKeys = { no_exchange_rate: "shippingPlan.wms.noExchangeRate", already_booked: "shippingPlan.wms.alreadyBooked" };
          const key = reasonKeys[reason] || "shippingPlan.wms.bookError";
          this.$notify({
            timeout: 3500,
            message: this.$t(key),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.wmsBookingSubmitting = false;
        });
    },
    openAfterbuyBooking(row) {
      this.afterbuyBookingRecordId = row.shipmentRecordId;
      this.afterbuyBookingPreview = null;
      this.afterbuyBookingLoading = true;
      this.afterbuyBookingModal = true;
      axiosFactory()
        .get(`/shipping_plans/${row.shipmentRecordId}/afterbuy_booking_preview`)
        .then((res) => {
          this.afterbuyBookingPreview = res.data.data;
        })
        .catch(() => {
          this.$notify({
            timeout: 3000,
            message: this.$t("shippingPlan.afterbuy.previewError"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.hideAfterbuyBooking();
        })
        .finally(() => {
          this.afterbuyBookingLoading = false;
        });
    },
    hideAfterbuyBooking() {
      this.afterbuyBookingModal = false;
      this.afterbuyBookingPreview = null;
      this.afterbuyBookingRecordId = null;
    },
    confirmAfterbuyBooking() {
      // Doppelklick-Schutz (Kundenfall 21.08., Container doppelt gebucht): waehrend der
      // laufenden Buchung feuert kein zweiter Request - der Server claimt zusaetzlich atomar
      if (!this.canConfirmAfterbuyBooking || this.afterbuyBookingSubmitting) {
        return;
      }
      this.afterbuyBookingSubmitting = true;
      const id = this.afterbuyBookingRecordId;
      this.isLoading = true;
      axiosFactory()
        .post(`/shipping_plans/${id}/book_to_afterbuy`)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("shippingPlan.afterbuy.bookSuccess"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.hideAfterbuyBooking();
          this.applyFilters({});
        })
        .catch((err) => {
          const reason = err.response && err.response.data && err.response.data.reason;
          const key =
            reason === "not_found_in_afterbuy"
              ? "shippingPlan.afterbuy.notAllFound"
              : reason === "afterbuy_offline"
              ? "shippingPlan.afterbuy.offline"
              : reason === "not_confirmed"
              ? "shippingPlan.afterbuy.notConfirmed"
              : reason === "afterbuy_error"
              ? "shippingPlan.afterbuy.afterbuyError"
              : "shippingPlan.afterbuy.bookError";
          this.$notify({
            timeout: 3500,
            message: this.$t(key),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.afterbuyBookingSubmitting = false;
        });
    },
    hasPermission(permissionName, tableName, columnName) {
      return hasPermission(permissionName, tableName, columnName);
    },
    isAdmin() {
      return isAdmin();
    },
    getI18N(prefix, statusName) {
      return this.$t(`${prefix}.${normalizeStatusName(statusName)}`);
    },
  },
  created() {
    Promise.all([
      this.$store.dispatch("shippingData/getRecordStatuses"),
      this.$store.dispatch("shippingData/getRecordTags"),
      this.$store.dispatch("shippingData/getSupplierNames"),
      this.$store.dispatch("shippingData/getContainerSizes"),
      this.$store.dispatch("shippingData/getContainerArrivalPlaces"),
      this.$store.dispatch("shippingData/getCarrierNames"),
      this.$store.dispatch("shippingData/getPaymentStatuses"),
      this.$store.dispatch("shippingData/getShipmentPaidStatuses"),
      this.$store.dispatch("shippingData/getCustomsPaidStatuses"),
      this.$store.dispatch("shippingData/getChinaStatuses"),
      this.$store.dispatch("shippingData/getLinkedProducts"),
      this.$store.dispatch("shippingData/getChinaUsers"),
      this.$store.dispatch("shippingData/getAccountingStatuses"),
    ]).then(() => {
      this.isLoading = false;
    });
  },
  mounted() {
    stickyTableHeader({ selector: "#shipping-plan-table" });
    EventBus.$on("language:changed", ({ locale }) => {
      numeral.locale(locale);
      this.applyFilters({});
    });

    this._signalrConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${config.baseURLApi}/hubs/shippingplan`, {
        // Der Hub verlangt Authentifizierung. SignalR haengt den Token als ?access_token an;
        // das gespeicherte Token traegt das "Bearer "-Prefix, das hier weg muss.
        accessTokenFactory: () => (TokenService.getToken() || "").replace(/^Bearer\s+/i, ""),
      })
      .withAutomaticReconnect()
      .build();

    this._signalrConnection.on("ShippingPlanUpdated", () => {
      this.$refs.table.refresh();
    });

    this._signalrConnection.onreconnected(() => {
      if (this.editModal && this.form.shipmentRecordId) {
        this.startEditingPresence(this.form.shipmentRecordId);
      }
    });

    this._signalrConnection.start().catch((err) => console.error("SignalR:", err));
  },
  updated() {
    EventBus.$emit("scroll:changed");
  },
  beforeDestroy() {
    EventBus.$off("language:changed");
    if (this._signalrConnection) {
      this._signalrConnection.stop();
    }
  },
};
</script>
<style>
.md-menu-content-bottom-start {
  z-index: 10001;
}
.china-tooltip {
  text-align: left;
  border-collapse: collapse;
}
.china-tooltip td {
  padding: 1px 0;
  vertical-align: top;
}
.china-tooltip td:first-child {
  padding-right: 10px;
  font-weight: 600;
  white-space: nowrap;
}
.md-select-menu .md-list-item-content {
  min-height: 48px;
  height: auto;
}
.md-select-menu .md-list-item-text,
.md-select-menu .md-list-item-text * {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
</style>
<style lang="css" src="./ShippingPlans.css"></style>
<style scoped>
/* Notizfeld waechst mit dem Text (md-autogrow), ab ca. 8 Zeilen Scrollbalken statt weiter wachsen */
.shipment-note-field ::v-deep .md-textarea {
  max-height: 12em;
  overflow-y: auto;
}
.wrap-v-select.mb-3 ::v-deep .vs__dropdown-toggle {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 0 !important;
}
.bearbeiter-col {
  position: relative;
  padding-top: 17px;
}
.bearbeiter-col .v-select-label {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
}
.table-transparent {
  background-color: transparent !important;
}

.mr-1 {
  margin-right: 15px;
}

.mt-0 {
  margin-top: 0 !important;
}

.documents i {
  color: #7f915a !important;
}
.md-success {
  background-color: #7f915a !important;
}
.empty-product {
  background-color: gray;
}

.date-title {
  margin-bottom: 0;
  text-align: left;
  font-size: 0.85em;
  color: #888;
}

.product-tab {
  padding: 4px 0;
  overflow-x: hidden;
}
.product-tab-header,
.product-tab-row {
  display: flex;
  align-items: center;
  gap: 50px;
}
.product-tab-header {
  font-size: 0.75em;
  color: #888;
  padding-bottom: 4px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 4px;
}
.product-tab-scroll {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.product-tab-row .md-field {
  margin: 0 !important;
  padding-top: 0 !important;
  min-height: 32px !important;
}
.product-tab-row .md-button.md-icon-button {
  margin: 0 !important;
  width: 32px;
  height: 32px;
  min-width: 32px;
}
.product-tab-row {
  margin-bottom: 4px;
}
.product-tab-row:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.04);
}
.product-tab-row:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
.product-tab-row {
  --vs-search-input-bg: transparent;
  --vs-disabled-bg: transparent;
  --vs-selected-bg: transparent;
  --vs-dropdown-bg: transparent;
  --vs-controls-bg: transparent;
}
.product-tab-row,
.product-tab-row * {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
}
.product-tab-row .md-button.md-icon-button {
  background-color: #999 !important;
}
.product-tab-row:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
.product-tab-row:hover {
  background-color: rgba(0, 0, 0, 0.08) !important;
}
.product-tab-header,
.product-tab-row {
  padding-left: 16px;
}
.product-col-handle { width: 24px; min-width: 24px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
.product-col-qty  { width: 80px;  min-width: 80px;  flex-shrink: 0; }
.product-col-sku  { width: 320px; min-width: 320px; flex-shrink: 0; }
.product-col-ek   { width: 100px; min-width: 100px; flex-shrink: 0; }
.product-col-del  { width: 32px;  min-width: 32px;  flex-shrink: 0; }
.product-handle {
  cursor: grab;
  color: rgba(0, 0, 0, 0.4) !important;
  font-size: 20px !important;
  user-select: none;
}
.product-handle:active { cursor: grabbing; }
.product-col-ek-with-suffix {
  display: flex;
  align-items: flex-end;
  gap: 4px;
}
.product-col-ek-with-suffix .md-field {
  flex: 1;
}
.product-col-ek-suffix {
  padding-bottom: 6px;
  color: rgba(0, 0, 0, 0.6);
}
.product-tab-row .product-col-sku {
  --vs-border-color: transparent;
  --vs-border-radius: 0;
  margin-top: -9px;
}
.product-tab-row .product-col-sku ::v-deep .vs__dropdown-toggle {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  padding: 0;
  min-height: 32px;
}
.product-tab-row .product-col-sku ::v-deep .vs__search,
.product-tab-row .product-col-sku ::v-deep .vs__selected {
  margin: 0;
  padding: 0;
  line-height: 32px;
  min-height: 32px;
}
.product-tab-row .product-col-sku ::v-deep .vs__actions {
  padding: 0;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.accounting-status-grid {
  display: grid;
  grid-template-columns: auto auto;
  gap: 2px;
  justify-items: start;
}
.status-pill {
  display: inline-flex;
  align-items: center;
  width: 30px;
  height: 16px;
  border-radius: 999px;
  padding: 0;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
}
.status-pill--on {
  background: #7f915a;
  flex-direction: row;
}
.status-pill--off {
  background: #f44336;
  flex-direction: row;
}
.status-pill-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}
.status-pill-badge .material-symbols-outlined {
  font-size: 11px !important;
  line-height: 1;
  color: #333;
}
.status-pill-badge img {
  width: 11px;
  height: 11px;
  object-fit: contain;
}
.status-pill-badge--logo {
  background: transparent;
  overflow: hidden;
}
.status-pill-badge--logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.status-pill-badge--datev {
  background: #7f915a;
}
.status-pill-badge--datev img {
  padding: 2px;
}
.stock-update-status {
  margin-bottom: 14px;
  padding: 8px 10px;
  background: #f5f5f5;
  border-radius: 4px;
}
.stock-update-status-row {
  display: flex;
  gap: 24px;
  margin-top: 6px;
}
.stock-update-status-row .material-symbols-outlined {
  font-size: 16px;
  vertical-align: middle;
}
.stock-update-status-hint {
  display: block;
  margin-top: 6px;
  color: #999;
}
.wms-booking-table {
  display: table;
  width: 100%;
  border-collapse: collapse;
}
.wms-booking-table thead {
  display: table-header-group;
}
.wms-booking-table tbody {
  display: table-row-group;
}
.wms-booking-table tr {
  display: table-row;
}
.wms-booking-table th,
.wms-booking-table td {
  display: table-cell;
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}
.wms-booking-table th {
  color: #7f915a;
  font-weight: 600;
}
.wms-booking-table .text-right {
  text-align: right;
}
.wms-booking-rate {
  margin-top: 12px;
  font-weight: 600;
}

.supplier-link {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
</style>
